// tslint:disable:max-file-line-count
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    Renderer2,
    ViewChild,
    ViewChildren,
} from "@angular/core";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import {
    clusterMarkerMapSettings,
    defaultMapSettings,
    drawingOptions,
    shapeMeasurementColor,
    shapeSelectColor,
} from "../../core/map/map.constants";
import { MapStateService } from "../map-state.service";
import { CircleTooltipHelper } from "../helpers/circle-tooltip.helper";
import {
    BehaviorSubject,
    forkJoin,
    ReplaySubject,
    Subject,
    Subscription,
} from "rxjs";
import { MapState } from "../../model/map/map-state";
import { MapStateActionEnum } from "../../model/map/map-state-action.enum";
import { CircleDrawing } from "../../model/map/drawing/circle-drawing";
import { RectangleDrawing } from "../../model/map/drawing/rectangle-drawing";
import {
    AgmInfoWindow,
    Circle,
    DataMouseEvent,
    LatLngBoundsLiteral,
    LatLngLiteral,
    MapTypeStyle,
    MouseEvent,
} from "@agm/core";
import {
    MapDetails,
    MapInfoBoxComponent,
} from "./info-box/map-info-box.component";
import { DatapointsPageStateService } from "../../dataset/datapoints/datapoints-page-state.service";
import { MapDrawType } from "../../model/map/map-draw-type";
import { DatapointsFilterService } from "../../dataset/datapoints/datapoints-filter.service";
import { MapViewType } from "../../model/map/map-view-type";
import { MapThematicOverlayService } from "../map-thematic-overlay.service";
import { debounceTime, skip } from "rxjs/operators";
import { PolygonPathEvent } from "@agm/core/directives/polygon";
import { MapStateForImageOverlays } from "../../model/map/map-state-for-image-overlays";
import { Point } from "../../model/geometry/point";
import { MapLocation } from "../../model/map/map-location";
import { Location as GMALocation } from "@angular-material-extensions/google-maps-autocomplete/lib/interfaces/location.interface";
import { MapInteractionMode } from "../../dataset/datapoints/map-interaction-mode";
import { TessadataService } from "../../data-access-layer/tessadata.service";
import { MapInteractionStatus } from "../../dataset/datapoints/map-interaction-status";
import { ClusteringService } from "../../dataset/clustering/clustering.service";
import { Cluster } from "../../dataset/clustering/cluster";
import { ClusteringRequest } from "../../dataset/clustering/clustering-request";
import { DatasetField } from "../../model/dataset/field/dataset-field";
import { Observable } from "rxjs/internal/Observable";
import { GeocodingService } from "../../shared/services/geo-coder.service";
import { GeographicalRegion } from "../../model/geographical-region/geographical-region";
import AerisWeather from "@aerisweather/javascript-sdk";
import { AerisType } from "../../core/aeris/AerisType";
import { ImageOverlay } from "../../model/overlay/external/image-overlay";
import { environment } from "../../../environments/environment";
import { AerisService } from "../../data-access-layer/aeris.service";
import { MapShape } from "../../model/map/map-shape";
import { OverlayType } from "../../model/map/overlay-type";
import {
    DrawSession,
    DrawKind,
    DragDrawKind,
    VertexDrawKind
} from "../../model/map/draw-session";
import { AerisDescriptions } from "../../core/aeris/AerisDescriptions";
import {
    FetchLimitParam,
    numberOfAerisRequestsWithinShapes,
} from "../../core/aeris/AerisConsts";
import { ActivatedRoute } from "@angular/router";
import { ObjAerisType } from "../../core/aeris/AerisApiData";
import { ShapeDebouncer } from "./shape-debouncer";
import { PolygonDrawing } from "../../model/map/drawing/polygon-drawing";
import { NotifService } from "../../core/notification/notif.service";
import { PolylineDrawing } from "../../model/map/drawing/polyline-drawing";
import {
    Crisis24Alert,
    Crisis24Circle,
} from "src/app/model/datapoint/crisis24-alert";
import { isUndefined } from "src/app/core/utils/util-master";
import { LocationProfile } from "src/app/model/datapoint/location-profile/location-profile";
//import { TensorflightStatus } from "src/app/dataset/datapoints/tensorflight-keys";
import { OpenWeather } from "src/app/model/datapoint/open-weather";
import { DatapointsService } from "src/app/data-access-layer/datapoints/datapoints.service";
import { MapIcons } from "./map-icons";
import { defaultMapStyles, worldMapStyles } from "./map-style";
import { Aeris } from "src/app/core/utils/aeris";
import { DataPointsServiceState } from "src/app/shared/services/datapoints-service-state";
import { HeatmapResponse } from "src/app/dataset/clustering/heatmap-response";
import { AccumulationsService } from "src/app/shared/services/accumulations.service";
import { ProfilePolygonService } from "src/app/shared/services/profile-polygon.service";
import { DecimalPipe } from "@angular/common";
import { LayerExposedService } from "src/app/account/layer-exposed/services/layer-exposed.service";
import { FormBuilder, FormControl, UntypedFormGroup } from "@angular/forms";
import { AccountService } from "src/app/data-access-layer/account/account.service";
import { Account } from "src/app/model/account/account";
import { GroupService } from "src/app/data-access-layer/groups/group.service";
import { DatapointsAggregateService } from "src/app/data-access-layer/datapoints/datapoints-aggregate.service";
import { UserStateService } from "src/app/auth/user-state-service";
import { DatasetFieldScope } from "src/app/model/dataset/dataset-field-scope";
import { SeeInfoSearchBarStateService } from "src/app/dataset/datapoints/see-info-search-bar-state.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MapMarkerVisualizationMode } from "src/app/model/dataset/dataset-config-filter.enum";
import { AnalyticsService } from "src/app/core/services/analytics.service";
import { CircleSelectionStateService } from "../../services/circle-selection-state.service";
import { CircleSelectionConfig, RadiusUnit } from "../../model/map/circle-selection-config";

declare var google: any;

@Component({
    selector: "map-map",
    templateUrl: "./map.component.html",
    styleUrls: ["./map.component.scss"],
})
export class MapComponent implements OnInit, OnDestroy {
    @Input() isThematicMapEnabled: boolean;
    @Output() mapReady = new ReplaySubject(1);
    @Output() DetailsOpen = new EventEmitter<MapDetails>();
    @Output() onCustomLocationDetailsSelected = new EventEmitter<Point>();
    @Input() geoRegion: GeographicalRegion;
 //   @Input() externalTensorFlightData: any;
    @Input() externalPreciselyDataForMap: any;
    @Input() externalPreciselyWildfireDataForMap: any;

    activeMarker: Point;
    markerAnimation: string;
    activeMarkerEditMode = false;
    markerIsInitialized: boolean;

    mapType: { type: string; iconSource: string; displayName?: string };

    mapSettings = {...defaultMapSettings};
    clusterMarkerMapSettings = {...clusterMarkerMapSettings};
    drawingOptions = drawingOptions;
    shapeMeasurementColor = shapeMeasurementColor;
    shapeSelectColor = shapeSelectColor;

    /**
     * Stroke/fill for Location Profile boundary polygons. Deliberately distinct from
     * shapeSelectColor: a block group is the area a location sits inside, not a selected shape, so
     * it should not read as a selection.
     */
    profileBoundaryColor = '#7b1fa2';

    clusters: Cluster[];
    clusterSettings: ClusteringRequest;
    clusteringField: DatasetField;

    polygons: { measure: PolygonDrawing[]; select: PolygonDrawing[] };
    polylines: { measure: PolylineDrawing[] };
    circles: { measure: CircleDrawing[]; select: CircleDrawing[] };
    rectangles: { measure: RectangleDrawing[]; select: RectangleDrawing[] };

    circleMoveMode: boolean = false;
    rectangleMoveMode: boolean = false;

    public circleIconHover: boolean[] = [];
    public rectangleIconHover: boolean[] = [];
    public polygonIconHover: boolean[] = [];

    // Generate SVG data URL for info icon with white background, black border, bold italic 'i'
    public getShapeInfoIconUrl(isHover: boolean = false): string {
        const backgroundColor = isHover ? '#F0F0F0' : '#FFFFFF';
        const borderColor = '#000000';
        const textColor = '#000000';

        const svg = `<?xml version="1.0" encoding="UTF-8"?>
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="${backgroundColor}" stroke="${borderColor}" stroke-width="2"/>
                <text x="12" y="17" font-family="Arial, sans-serif" font-size="14" font-style="italic" font-weight="bold" fill="${textColor}" text-anchor="middle">i</text>
            </svg>
        `.trim();
        
        return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
    }
    
    // Debug method to check circles
    public logCirclesCount(): void {
        console.log('Circles select count:', this.circles?.select?.length || 0);
        console.log('Circles select:', this.circles?.select);
    }
    
    // Get custom circles count for debugging
    public getCustomCirclesCount(): number {
        return this.customCircles?.length || 0;
    }
    
    // Create info icon marker for custom circle
    private createInfoIconForCustomCircle(circleIndex: number): void {
        const customCircle = this.customCircles[circleIndex];
        if (!customCircle || !this.mapElement) {
            return;
        }
        
        const circle = customCircle.circle;
        const center = circle.getCenter();
        const radius = circle.getRadius();
        
        if (!center) {
            return;
        }
        
        // Calculate top-right position just outside the circle boundary
        const radiusInDegrees = radius / 111320;
        const fixedOffset = 0.0002; // Fixed offset (~22 meters) to place icon adjacent to circle edge
        
        const iconPosition = {
            lat: center.lat() + radiusInDegrees + fixedOffset,
            lng: center.lng() + radiusInDegrees + fixedOffset
        };
        
        // Create info icon marker (draggable to move the circle)
        const infoIconMarker = new google.maps.Marker({
            position: iconPosition,
            map: this.mapElement,
            icon: {
                url: this.getShapeInfoIconUrl(false),
                scaledSize: new google.maps.Size(24, 24) // Smaller icon size
            },
            zIndex: 1000,
            draggable: true, // Make draggable so user can drag circle via icon
            clickable: true
        });
        
        // Add left-click listener to open area info window
        infoIconMarker.addListener('click', () => {
            const areaInfoWindow = (customCircle as any).areaInfoWindow;
            if (areaInfoWindow) {
                // Close any other open InfoWindows and show their radius labels
                this.customCircles.forEach((item, idx) => {
                    if (idx !== circleIndex && (item as any).areaInfoWindow) {
                        (item as any).areaInfoWindow.close();
                        // Show radius label for other circles
                        if (item.radiusLabel) {
                            item.radiusLabel.open(this.mapElement);
                        }
                    }
                });
                
                // Hide permanent radius label to prevent overlap
                this.hidePermanentLabel(circleIndex);
                
                // Open this InfoWindow
                areaInfoWindow.open(this.mapElement);
            }
        });
        
        // Add hover effect
        infoIconMarker.addListener('mouseover', () => {
            infoIconMarker.setIcon({
                url: this.getShapeInfoIconUrl(true),
                scaledSize: new google.maps.Size(24, 24)
            });
        });
        
        infoIconMarker.addListener('mouseout', () => {
            infoIconMarker.setIcon({
                url: this.getShapeInfoIconUrl(false),
                scaledSize: new google.maps.Size(24, 24)
            });
        });
        
        // Add drag listeners to move circle when icon is dragged
        infoIconMarker.addListener('drag', () => {
            const iconPos = infoIconMarker.getPosition();
            if (iconPos) {
                // Calculate circle center from icon position
                // Icon is at top-right, so circle center is at icon position minus radius and fixed offset
                const radiusInDegrees = circle.getRadius() / 111320;
                const fixedOffset = 0.0002; // ~22 meters, matching polygon logic
                const newCenter = {
                    lat: iconPos.lat() - radiusInDegrees - fixedOffset,
                    lng: iconPos.lng() - radiusInDegrees - fixedOffset
                };
                
                // Move circle and center marker to new position
                circle.setCenter(newCenter);
                customCircle.marker.setPosition(newCenter);
                
                // Update radius label position to follow the circle
                if (customCircle.radiusLabel) {
                    customCircle.radiusLabel.setPosition(newCenter);
                }
            }
        });
        
        infoIconMarker.addListener('dragend', () => {
            const iconPos = infoIconMarker.getPosition();
            if (iconPos) {
                // Calculate final circle center
                const radiusInDegrees = circle.getRadius() / 111320;
                const fixedOffset = 0.0002; // ~22 meters, matching polygon logic
                const newCenter = {
                    lat: iconPos.lat() - radiusInDegrees - fixedOffset,
                    lng: iconPos.lng() - radiusInDegrees - fixedOffset
                };
                
                // Update the circle data in our tracking array
                if (this.customCircles[circleIndex]) {
                    this.customCircles[circleIndex].data.latitude = newCenter.lat;
                    this.customCircles[circleIndex].data.longitude = newCenter.lng;
                }
                
                // Update filter service with ALL custom circles
                this.updateFilterWithAllCircles();
            }
        });
        
        // Store reference to info icon marker in separate property (not in resizeHandles)
        customCircle.infoIconMarker = infoIconMarker;
        
        console.log('Created info icon for custom circle', circleIndex, 'at position:', iconPosition);
    }

    isMeasurementDrawing: boolean;
    showPlayButton: boolean;
    isAnimating: boolean;
    interactiveLayers: string[] = [];
    shapeUpdateDebouncer: ReplaySubject<ShapeDebouncer>;
    mapStatus: MapInteractionStatus;
    interactiveOverlayShapes: GeojsonMapItem[];
    // externalDatasetShapeStyle = {fillColor: '#ff0000', strokeWeight: 2, strokeColor: '#444', fillOpacity: 0.5};
    searchResultMarker$: BehaviorSubject<MapLocation> =
        this.mapStateService.activeSearchResultMarker$;
    currentPinAddress: Observable<string>;
    regionsShapes: GeojsonMapItem[];
    crises24CircleObjects: Circle[] = [];
    private aerisMap;
    private mapElement: google.maps.Map;
    // DrawingManager was removed from the Maps JS API in v3.65.3b and all four
    // shapes are now captured in-house (see "In-house shape capture" below), so
    // these and the addDrawingManager/clearDrawingManager/onShapeDrawComplete
    // block are commented out rather than deleted, pending the migration sign-off.
    // private drawingManager: google.maps.drawing.DrawingManager | null = null;
    // private overlayCompleteListener: google.maps.MapsEventListener;
    private readonly subscription: Subscription = new Subscription();

    destroy$: Subject<void> = new Subject();
    
    // Circle Selection Tool constants
    private readonly CIRCLE_MIN_RADIUS_METERS = 1000;
    private readonly METERS_TO_DEGREES_CONVERSION = 111320;
    private readonly RESIZE_HANDLE_DISMISS_DELAY_MS = 500;
    private readonly HELPER_TOOLTIP_AUTO_DISMISS_MS = 5000;
    
    // Circle Selection Tool properties
    private circlePlacementClickListener: google.maps.MapsEventListener | null = null;
    private isInCirclePlacementMode = false;

    private customCircles: Array<{
        circle: google.maps.Circle;
        marker: google.maps.Marker;
        data: CircleDrawing;
        radiusLabel?: google.maps.InfoWindow;
        selectedUnit?: string; // User's selected unit (miles, kilometers, meters)
        resizeHandles?: google.maps.Marker[]; // Resize handles for this circle
        resizeTooltip?: google.maps.InfoWindow; // Tooltip shown during resize
        infoIconMarker?: google.maps.Marker; // Info icon marker (separate from resize handles)
    }> = [];
  //  tensorFlightPolygonData: { paths: LatLngLiteral[] };
    preciselyPolygonData: { paths: LatLngLiteral[] };
    preciselyWildfirePolygonData: { paths: LatLngLiteral[] };
    isPreciselyWildfireFirstTimeFetched: any = true;
    clickedCoords: LatLngLiteral;
    currentMapBounds: LatLngBoundsLiteral | null = null;
    previousMapBounds: LatLngBoundsLiteral | null = null;
    currentZoom: number;
    preservedZoom: number;
  //  isTensorflightFirstTimeFetched: any = true;
    isPreciselyFirstTimeFetched: any = true;
    areBoundsChanged: any = false;
    openWeatherInfoWindow: google.maps.InfoWindow;
    openWeatherAlertsObjects: Map<string, any> = new Map<string, any>();
    openWeatherpolygons: {
        polygon: google.maps.Polygon;
        params: {
            geometryId: string;
            event_name: String;
            start_date: String;
            end_date: String;
        };
    }[] = [];
    mapOption: { type: string; iconSource: string; displayName?: string }[];

    heatMap: google.maps.visualization.HeatmapLayer;

    @Input("activeMarker")
    set setActiveMarker(point: Point) {
        this.activeMarker = point;
    }

    @Input("activeMarkerEditMode")
    set setActiveMarkerEditMode(active: boolean) {
        this.activeMarkerEditMode = active;
        if (active) {
            this.markerAnimation = "BOUNCE";
        } else {
            this.markerAnimation = undefined;
        }
    }

    address: any;
    locationProfile = new LocationProfile();
    aerisCredentials: {
        aerisClient: string;
        aerisSecret: string;
    };

    get customMapStyles() {
        // Return world map styles if WORLD_MAP view is selected, otherwise return default styles
        if (this.mapType?.type === MapViewType.WORLD_MAP) {
            return worldMapStyles;
        }
        return defaultMapStyles;
    }

    get mapTypeId() {
        // Convert WORLD_MAP to roadmap for Google Maps API, as WORLD_MAP is a custom view
        if (this.mapType?.type === MapViewType.WORLD_MAP) {
            return MapViewType.ROADMAP;
        }
        return this.mapType?.type;
    }

    get isWorldMapView() {
        return this.mapType?.type === MapViewType.WORLD_MAP;
    }

    // Natural Earth 1:110m land polygons (public domain). Google draws no stroke on water,
    // so the continent outline is drawn as geometry here, above the tile overlays.
    readonly worldLandGeoJson = 'assets/geojson/world-land.geojson';
    readonly worldLandStyle: google.maps.Data.StyleOptions = {
        strokeColor: '#9e9e9e',
        strokeWeight: 1.2,
        strokeOpacity: 1,
        fillOpacity: 0,
        clickable: false,  // must not swallow map clicks used by select/measure
        zIndex: 1
    };

    showDynamicIndicatorPopup = false;
    dynamicIndicatorLayerExposureData: any;
    showDynamicIndicatorSettings = false;
    createDropdownForm: UntypedFormGroup;
    dynamicDropDownList: any;
    defaultBottom = 65;
    defaultRight = 10;
    iconPosition = { x: null, y: null };
    isDragging = false;
    dragOffset = { x: 0, y: 0 };
    dragMoved = false;
    popupPosition = { x: null, y: null };
    firstPopupPosition = { x: null, y: null };
    secondPopupPosition = { x: null, y: null };
    popupWidth = 300;
    dynamicIndicatorValues: any[] = [];
    accountDetails: Account;
    pendingRequests: Set<number> = new Set();
    filterChanged = false;
    accountId: any;
    showSearchInfo = false;
    @ViewChildren('info') infoWindows!: QueryList<AgmInfoWindow>;
    @ViewChild('vertexInfo') vertexInfoWindow!: AgmInfoWindow;
    vertexInfoLat!: number;
    vertexInfoLng!: number;
    selectedPolygonIndex: number = -1;
    selectedVertexIndex: number = -1;
    polygonLocked: boolean[] = [];
    polygonMoveEnabled: boolean[] = [];
    originalCoords: { lat: number; lng: number }[][] = [];
    rotating: boolean[] = [];
    private pathListeners: google.maps.MapsEventListener[] = [];
    private lockedVertexCoords: { lat: number; lng: number; index: number }[] = [];
    private previousMovePoint: { lat: number; lng: number }[] = [];
    private suppressSetAt = false;
    private rotationAngles: number[] = [];
    private lastDragPoint: ({ lat: number; lng: number } | null)[] = [];
    private prevPolygonCount: number = 0;
    private rotationBaseCoords: { lat: number; lng: number }[][] = [];
    private rotationSessionBaseCoords: { lat: number; lng: number }[][] = [];
    private rotationSessionStartAngle: number[] = [];
    private rotationSessionCoords: { lat: number; lng: number }[][] = [];
    private shapeCoords: { lat: number; lng: number }[][] = [];
    private sessionBaseCoords: { lat: number; lng: number }[][] = [];
    private sessionStartAngle: number[] = [];
    private pivotInfo: { lat: number; lng: number; index: number }[] = [];
    private isRotating: boolean[] = [];
    private prevCount = 0;
    readonly ROUND_COORD_VALUE = 1e6
    private polarCoords: PolarVertex[][] = [];
    private sessionBasePolar: PolarVertex[][] = [];
    private sessionStartHeading: number[] = [];
    readonly DEGREE_540 = 540;
    readonly DEGREE_360 = 360;
    readonly DEGREE_180 = 180;
    undoAvailable: boolean[] = [];
    constructor(
        // Public: the template reads profilePolygonService.polygons to draw Location Profile
        // boundaries. Kept in a service rather than as fields here - see ProfilePolygonService.
        public readonly profilePolygonService: ProfilePolygonService,
        private readonly mapStateService: MapStateService,
        private readonly datapointsPageStateService: DatapointsPageStateService,
        private readonly datapointsFilterService: DatapointsFilterService,
        private readonly mapThematicOverlayService: MapThematicOverlayService,
        private readonly clusteringService: ClusteringService,
        private readonly tessadataService: TessadataService,
        private geocodingService: GeocodingService,
        private readonly cd: ChangeDetectorRef,
        private readonly aerisService: AerisService,
        private readonly route: ActivatedRoute,
        public readonly notifService: NotifService,
        public readonly datapointService: DatapointsService,
        public dataPointsServiceState: DataPointsServiceState,
        public readonly accumulationsSerivce: AccumulationsService,
        private decimalPipe: DecimalPipe,
        private layerExposeService: LayerExposedService,
        private readonly accountService: AccountService,
        private readonly groupService: GroupService,
        private readonly datapointsAggregateService: DatapointsAggregateService,
        private fb: FormBuilder,
        readonly userStateService: UserStateService,
        private renderer: Renderer2,
        private popupService: SeeInfoSearchBarStateService,
        private snackBar: MatSnackBar,
        private zone: NgZone,
        private analytics: AnalyticsService,
        private readonly circleSelectionStateService: CircleSelectionStateService
    ) {
        this.mapElement = null;
        this.polygons = { measure: [], select: [] };
        this.polylines = { measure: [] };
        this.circles = { measure: [], select: [] };
        this.rectangles = { measure: [], select: [] };
        // Commented out with the rest of the DrawingManager path - shapes are
        // captured in-house now and nothing holds a manager instance.
        // this.drawingManager = null;
        this.isMeasurementDrawing = true;
        this.mapType = {
            type: defaultMapSettings.mapType,
            iconSource: MapIcons[defaultMapSettings.mapType],
            displayName: defaultMapSettings.mapType === MapViewType.WORLD_MAP ? 'GRAY' : defaultMapSettings.mapType.replace('_', ' ').toUpperCase()
        };
        this.isThematicMapEnabled = false;
        this.shapeUpdateDebouncer = new ReplaySubject<ShapeDebouncer>(1);

        this.currentPinAddress = this.mapStateService.getCurrentPinAddress();
        this.regionsShapes = [];
        this.isAnimating = false;
        this.mapOption = this.getMapViewType();
        this.mapType = this.mapOption.find(
            (option) => option.type === defaultMapSettings.mapType
        );
        this.accountId = +this.route.snapshot.paramMap.get("accountId")
    }

    ngOnInit() {
        this.renderer.addClass(document.body, 'custom-recaptcha-page');
        this.aerisService.getAerisCredentials().subscribe((value: any) => {
            this.aerisCredentials = Aeris.decodeAerisCredentials(
                value.aerisClient,
                value.aerisSecret
            );
        });

        this.subscription.add(
            this.datapointsPageStateService
                .onMapInteractionChange()
                .subscribe((newStatus) => {
                    this.mapStatus = newStatus;
                    this.interactiveOverlayShapes = [];
                })
        );
        this.subscription.add(
            this.accumulationsSerivce
                .onHeatmapActivated()
                .subscribe((response) => {
                    if (!response) {
                        this.heatMap?.setMap(null);
                    } else {
                        this.prepareHeatMap(response);
                    }
                })
        );
        this.subscription.add(
            this.clusteringService
                .onClusteringActivated()
                .subscribe((clusteringResponse) => {
                    this.clusterSettings = this.clusteringService.getSettings();
                    this.clusteringField = this.datapointsPageStateService
                        .getActiveDatasetFields()
                        .get(this.clusterSettings.fieldId);
                    this.clusters = clusteringResponse.clusters;
                })
        );
        this.subscription.add(
            this.clusteringService
                .onClusterAnimationNeeded()
                .subscribe((clusterIndex) => {
                    // this.clusters.forEach(cluster => cluster.showInfo = false);
                    this.onClusterClick(this.clusters[clusterIndex]);
                })
        );
        this.subscription.add(
            this.clusteringService.onClusteringDisabled().subscribe((v) => {
                this.clusterSettings = null;
                this.clusters = [];
            })
        );
        this.subscription.add(
            this.mapStateService
                .getMarkerIsInitializedSubject()
                .subscribe((value) => {
                    this.markerIsInitialized = value;
                })
        );

        // this.subscription.add(
        //     this.dataPointsServiceState
        //         .getTensorflightAddressProfilePolygon()
        //         .subscribe((value: string) => {
        //             const parsedValue = value ? JSON.parse(value) : null;
        //             this.createAddressProfileTensorflightPolygon(parsedValue);
        //         })
        // );
        this.subscription.add(
            this.profilePolygonService.zoomRequested$.subscribe((profileKey: string) => {
                const polygon = this.profilePolygonService.polygons[profileKey];
                if (!polygon || !polygon.paths.length) {
                    return;
                }
                const bounds = new google.maps.LatLngBounds();
                for (const path of polygon.paths) {
                    bounds.extend(new google.maps.LatLng(path.lat, path.lng));
                }
                this.mapElement.fitBounds(JSON.parse(JSON.stringify(bounds)));
            })
        );

        this.subscription.add(
            this.dataPointsServiceState
                .getPreciselyAddressProfilePolygon()
                .subscribe((value: string) => {
                    const parsedValue = value ? JSON.parse(value) : null;
                    this.createAddressProfilePreciselyPolygon(parsedValue);
                })
        );

        this.subscription.add(
            this.popupService.isPopupVisible$.subscribe(
                visible => this.showSearchInfo = visible
            )
        );
        
        // Task 3: Subscribe to circle placement mode changes
        this.subscription.add(
            this.circleSelectionStateService.placementMode$.subscribe(
                (isPlacementMode) => {
                    if (isPlacementMode) {
                        this.enterCirclePlacementMode();
                    } else {
                        this.exitCirclePlacementMode();
                    }
                }
            )
        );


        // Rectangle capture: drag one corner to the opposite one (no DrawingManager).
        // The emitted value is the draw target, or null when the tool is disarmed.
        this.subscription.add(
            this.circleSelectionStateService.rectangleDrawMode$.subscribe(
                (target) => {
                    if (target) {
                        this.enterRectangleDrawMode(target);
                    } else {
                        this.exitRectangleDrawMode();
                    }
                }
            )
        );

        // Polygon capture: click once per vertex (no DrawingManager)
        this.subscription.add(
            this.circleSelectionStateService.polygonDrawMode$.subscribe(
                (target) => {
                    if (target) {
                        this.enterPolygonDrawMode(target);
                    } else {
                        this.exitPolygonDrawMode();
                    }
                }
            )
        );

        // Polyline capture: Measure > Distance (no DrawingManager)
        this.subscription.add(
            this.circleSelectionStateService.polylineDrawMode$.subscribe(
                (target) => {
                    if (target) {
                        this.enterPolylineDrawMode(target);
                    } else {
                        this.exitPolylineDrawMode();
                    }
                }
            )
        );

        // Circle drag capture: Measure > Circle (no DrawingManager)
        this.subscription.add(
            this.circleSelectionStateService.circleDragDrawMode$.subscribe(
                (target) => {
                    if (target) {
                        this.enterCircleDragDrawMode(target);
                    } else {
                        this.exitCircleDragDrawMode();
                    }
                }
            )
        );
    }

    onClusterClick(cluster: Cluster) {
        cluster.showInfo = true;
        this.clusteringService.clusterSelected(cluster);
    }

    get DatapointsMapMode() {
        return MapInteractionMode;
    }

    get MapDrawType() {
        return MapDrawType;
    }

    get MapShape() {
        return MapShape;
    }

    private initMarker() {
        const center = this.mapElement.getCenter();
        this.mapStateService.activeSearchResultMarker$.next({
            latitude: center.lat(),
            longitude: center.lng(),
        });
        this.mapStateService.emitMarkerIsInitialized(true);
    }

    onInteractiveMapAdded(overlay: ImageOverlay, opacity: number): void {
        let coordinates;
        if (
            !this.geocodingService.currentPinAddress &&
            !this.markerIsInitialized
        ) {
            coordinates = this.mapElement.getCenter();
        } else {
            coordinates = {
                lng: () => this.searchResultMarker$.value.longitude,
                lat: () => this.searchResultMarker$.value.latitude,
            };
        }

        if (!this.aerisMap) {
            const aeris = new AerisWeather(
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret
            );
            aeris.views().then((views) => {
                this.aerisMap = new views.InteractiveMap(this.mapElement, {
                    layers: [
                        {
                            layer: overlay.id,
                            options: {
                                style: {
                                    opacity,
                                },
                            },
                        },
                    ],
                    timeline: {
                        from: -3 * 3600,
                        to: 0,
                    },
                });

                // must wait for map to be ready before trying to update its view
                this.aerisMap.on("ready", () => {
                    this.showPlayButton = true;
                    this.aerisMap.setCenter({
                        lat: coordinates.lat(),
                        lon: coordinates.lng(),
                    });
                    this.aerisMap.setZoom(this.mapElement.getZoom());
                    this.interactiveLayers.push(overlay.id);
                });

                this.aerisMap.on("timeline:play", () => {
                    this.isAnimating = true;
                    this.cd.detectChanges();
                });

                this.aerisMap.on("timeline:stop", () => {
                    this.isAnimating = false;
                    this.cd.detectChanges();
                });

                // account info is needed to request alert-related data from the API for the alerts legend
                const account = aeris.account();

                const legend = new views.Legend("#aerisLegend", {
                    size: {
                        width: 340,
                    },
                    styles: {
                        label: {
                            color: "#ffffff",
                        },
                    },
                });

                // `map` is an instance of InteractiveMap
                // add and remove legends when layers are added and/or removed from the map
                this.aerisMap
                    .on("layer:add", (e) => {
                        const { layer, id } = e.data || {
                            layer: null,
                            id: null,
                        };
                        const keys = layer || id;
                        if (keys) {
                            // some keys contain multiple layers, so add a legend for each as needed
                            const layers = keys
                                .replace(/\:[^,]+/g, "")
                                .split(",");
                            layers.forEach((code) => {
                                legend.add(code, {
                                    account: account,
                                });

                                // the "alerts" legend requires the current map bounds
                                if (
                                    code === "alerts" ||
                                    /^alerts-/.test(code)
                                ) {
                                    setTimeout(() => {
                                        legend.update({
                                            account: account,
                                            within: {
                                                bounds: this.aerisMap.getBounds(),
                                            },
                                        });
                                    }, 500);
                                }
                            });
                        }
                    })
                    .on("layer:remove source:remove", (e) => {
                        const { layer, id } = e.data || {
                            layer: null,
                            id: null,
                        };
                        const keys = layer || id;
                        if (keys) {
                            // some keys contain multiple layers, so remove the legend for each as needed
                            const layers = keys
                                .replace(/\:[^,]+/g, "")
                                .split(",");
                            layers.forEach((code) => {
                                legend.remove(code);
                            });
                        }
                    })
                    .on("change:bounds", (e) => {
                        if (this.aerisMap) {
                            const opts = { account: account, within: {} };

                            // if active layers contains `alerts`, we need to pass the maps current bounds, size
                            // and zoom to be used to request a filtered version of the advisories legend just
                            // for the map region
                            if (this.aerisMap.getBounds()) {
                                opts.within = {
                                    bounds: this.aerisMap.getBounds(),
                                };
                            }
                            legend.update(opts);
                        }
                    });
            });
        } else {
            this.aerisMap.addLayer(overlay.id);
            this.showPlayButton = true;
            this.interactiveLayers.push(overlay.id);
        }
    }

    toggleInteractiveMapAnimation() {
        if (this.aerisMap.timeline.isAnimating()) {
            this.aerisMap.timeline.stop();
        } else {
            this.aerisMap.timeline.play();
        }
    }

    onInteractiveMapRemoved(overlay: ImageOverlay): void {
        this.aerisMap.removeLayer(overlay.id);
        const elementToRemove = this.interactiveLayers.findIndex(
            (id) => id === overlay.id
        );
        this.interactiveLayers.splice(elementToRemove, 1);

        if (this.interactiveLayers.length === 0) {
            this.aerisMap = null;
            this.showPlayButton = false;
        }
    }

    onMapReady(event: any): void {
        this.mapElement = event;
        if(this.datapointsPageStateService.getActiveDataset().markerVisualizationMode === MapMarkerVisualizationMode.CLUSTERS_TO_MARKER_PINS) {
            this.mapSettings.zoom = clusterMarkerMapSettings.minZoom;
            this.mapSettings.minZoom = clusterMarkerMapSettings.minZoom;
            this.mapSettings.latitude = clusterMarkerMapSettings.latitude;
            this.mapSettings.longitude = clusterMarkerMapSettings.longitude;
        } else {
            this.mapSettings.zoom = defaultMapSettings.zoom;
            this.mapSettings.minZoom = defaultMapSettings.minZoom;
            this.mapSettings.latitude = defaultMapSettings.latitude;
            this.mapSettings.longitude = defaultMapSettings.longitude;
        }
        this.resetOpenWeatherVariables();
        this.openWeatherInfoWindow = new google.maps.InfoWindow();
        this.clearCrises24CircleObjectsArray();
        this.subscription.add(
            // TODO Investigate if anything else in the component requires unsubscribing.
            this.mapStateService
                .getActiveOverlaysSubject()
                .subscribe((state) => {
                    this.mapStateReducer(state);
                })
        );
        this.subscription.add(
            this.mapStateService
                .getActiveShapesSubject()
                .subscribe((newShape) => {
                    this.isMeasurementDrawing = false;
                    this.onShapeOverlayComplete(
                        newShape.overlayType,
                        newShape.overlay,
                        false
                    );
                })
        );
        this.mapStateService
            .getActiveCrisis24CirclesSubject()
            .subscribe((response) => {
                this.clearCrises24CircleObjectsArray();
                response.forEach((element) => {
                    this.drawCircle(element);
                });
            });
        this.mapStateService
            .getCrisis24CirclesRemoveFlag()
            .subscribe((response) => {
                if (response) {
                    this.activeMarker = null;
                    this.clearCrises24CircleObjectsArray();
                }
            });
        this.mapStateService
            .getOpenWeatherRemovePolygonFlag()
            .subscribe((response) => {
                if (response) {
                    this.resetOpenWeatherVariables();
                }
            });
        this.subscription.add(
            this.mapStateService
                .getActiveImageOverlaysSubject()
                .subscribe((mapState) => {
                    this.handleImageOverlaysMapChanges(mapState);
                })
        );
        this.subscription.add(
            this.shapeUpdateDebouncer
                .pipe(
                    // Debounced, not throttled.
                    //
                    // google.maps fires bounds_changed continuously while a shape is
                    // dragged or resized. throttleTime with leading:true pushed a
                    // filter update for intermediate positions as well as the final
                    // one, so a single drag issued several tile requests for
                    // different bounds. Those race: when an earlier, larger-area
                    // request resolves after the final one, the map is left showing
                    // datapoints for a position the shape no longer occupies -
                    // visible as a band of markers outside the shape, on whichever
                    // side it was dragged away from.
                    //
                    // Debouncing emits only once the shape has settled, so exactly
                    // one filter update and one tile fetch happen per gesture.
                    debounceTime(300)
                )
                .subscribe((value) => {
                    this.onGeometriesBoundsChange(
                        value.event,
                        value.index,
                        value.type,
                        value.action
                    );
                })
        );
        this.subscription.add(
            this.mapStateService
                .getActiveGeoRegionSubject()
                .subscribe((geoRegionFiltered) => {
                    this.analytics.trackEvent('geo_region_applied');
                    this.onApplyGeoRegionsGeometryOnMap(geoRegionFiltered);
                })
        );
        this.subscription.add(
            this.mapStateService
                .getClearFilteredRegionsSubject()
                .subscribe((value) => {
                    this.clearRegionsGeometries(value);
                })
        );
        this.mapReady.next(event);
    }

    onApplyGeoRegionsGeometryOnMap(geoRegionsFiltered) {
        this.regionsShapes = [];
        const color = this.getColorForRegionShape();
        const style = {
            fillColor: color,
            strokeColor: color,
            strokeWeight: 1,
            fillOpacity: 0.3,
            zIndex: -1,
            stylers: null,
        };
        if (geoRegionsFiltered) {
            geoRegionsFiltered.forEach((geoRegionFiltered) => {
                this.regionsShapes.push({
                    geojson: {
                        type: "Feature",
                        geometry: geoRegionFiltered.geometry,
                    },
                    showInfo: false,
                    style: style,
                    regionId: geoRegionFiltered.id,
                });
            });
        }
        this.datapointsFilterService.applyFilterForGeoRegions(
            this.regionsShapes
        );
    }

    getColorForRegionShape() {
        const color = "#104466";
        return color;
    }

    clearRegionsGeometries(value) {
        if (value) {
            this.regionsShapes = [];
            this.datapointsFilterService.applyFilterForGeoRegions(
                this.regionsShapes
            );
        }
    }

    private mapStateReducer(state: MapState) {
        switch (state.action) {
            case MapStateActionEnum.LOAD:
                break;
            case MapStateActionEnum.REDRAW_ALL:
                this.onStateRedrawAllAction(state);
                break;
            case MapStateActionEnum.UPDATE_OVERLAY:
                this.onStateUpdateOverlayAction(state);
                break;
            case MapStateActionEnum.INSERT_OVERLAY:
                this.onStateInsertOverlayAction(state);
                break;
            case MapStateActionEnum.REMOVE_OVERLAY:
                this.onStateRemoveOverlay(state.datasetID);
                break;
            case MapStateActionEnum.REFRESH_TILES:
                this.onStateRefreshTiles();
                break;
            case MapStateActionEnum.SHAPES:
                // Armed the DrawingManager. The in-house tools arm themselves
                // through CircleSelectionStateService instead, so this action is
                // now inert and only legacy drawShapes() callers still raise it.
                // this.addDrawingManager(state);
                break;
            case MapStateActionEnum.CLEAR_SHAPES:
                if (state.options.drawingType === MapDrawType.MEASURE) {
                    this.clearMeasureShapes();
                    // this.clearDrawingManager();
                }
                if (state.options.drawingType === MapDrawType.FILTER) {
                    // this.clearDrawingManager();
                    let haveActiveGeometries =
                        this.circles.select.length ||
                        this.rectangles.select.length ||
                        this.polygons.select.length ||
                        this.customCircles.length;
                    if (haveActiveGeometries) {
                        this.clearSelectShapes();
                    }
                }
        }
    }

    private onStateInsertOverlayAction(state: MapState): void {
        let datasetID = state.datasetID;
        let dataset = this.datapointsPageStateService.getDataset(datasetID);
        
        // Check if overlay is actually on the map (not just in the array)
        let existingMapIndex = this.mapElement.overlayMapTypes
            .getArray()
            .findIndex((map) => map.name === datasetID);
        
        if (existingMapIndex >= 0) {
            // Overlay is already on the map, no need to add it again
            return;
        }

        let locationDatasetId = this.route.snapshot.paramMap.get("datasetId") || "";
        if(datasetID !== locationDatasetId) {
            this.mapElement.overlayMapTypes.insertAt(0, state.map);
            // Only add to activeDatasetsOnMap if not already there
            let existingArrayIndex = this.datapointsPageStateService.activeDatasetsOnMap.findIndex(
                (ds) => ds.id === datasetID
            );
            if (existingArrayIndex < 0) {
                this.datapointsPageStateService.activeDatasetsOnMap.unshift(dataset);
            }
        } else {
            this.mapElement.overlayMapTypes.push(state.map);
            // Only add to activeDatasetsOnMap if not already there
            let existingArrayIndex = this.datapointsPageStateService.activeDatasetsOnMap.findIndex(
                (ds) => ds.id === datasetID
            );
            if (existingArrayIndex < 0) {
                this.datapointsPageStateService.activeDatasetsOnMap.push(dataset);
            }
        }
    }

    private onStateRemoveOverlay(datasetID: string): void {
        const indexOfOverlay = this.mapElement.overlayMapTypes
            .getArray()
            .findIndex((map) => map.name === datasetID);

        if (indexOfOverlay >= 0) {
            this.mapElement.overlayMapTypes.removeAt(indexOfOverlay);
        }

        // Independent ID-based lookup — NOT the overlayMapTypes index,
        // because the two arrays can have different orderings.
        const pageStateIndex = this.datapointsPageStateService.activeDatasetsOnMap
            .findIndex((ds) => ds.id === datasetID);

        if (pageStateIndex >= 0) {
            this.datapointsPageStateService.activeDatasetsOnMap.splice(pageStateIndex, 1);
        }
    }

    private onStateRedrawAllAction(state: MapState): void {
        this.mapElement.overlayMapTypes.clear();
    }

    private onStateRefreshTiles(): void {
        const overlays = this.mapElement.overlayMapTypes.getArray();
        overlays.forEach((overlay: google.maps.MapType, index: number) => {
            this.mapElement.overlayMapTypes.setAt(index, overlay);
        });
    }

    /**
     * If the overlay is not active already, it will be added instead of update
     */
    private onStateUpdateOverlayAction(state: MapState): void {
        let datasetID = state.datasetID;
        let existingLayerIndex = this.mapElement.overlayMapTypes
            .getArray()
            .findIndex((map) => map.name === datasetID);
        if (existingLayerIndex >= 0) {
            this.mapElement.overlayMapTypes.setAt(
                existingLayerIndex,
                state.map
            );
        } else {
            this.onStateInsertOverlayAction(state);
        }
    }

    onGeojsonClick(item: GeojsonMapItem, event: DataMouseEvent) {
        item.showInfo = true;
        item.clickedLocation = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
        };
    }

    onMapClick(event: MouseEvent, infoWindow: MapInfoBoxComponent) {
        console.log("ON CLICK");
        
        // Task 3/4: Prevent existing map click handling during circle placement mode
        if (this.isInCirclePlacementMode) {
            return;
        }

        // A click while a shape tool is armed places a vertex - it must not also
        // open the info box, which jumps straight to the Location Profile when the
        // click lands on a marker.
        if (this.drawSession) {
            return;
        }

        let currentMode =
            this.datapointsPageStateService.getMapInteractionStatus();
        if (
            currentMode.mode === MapInteractionMode.INTERACTION_DATASET_ACTIVE
        ) {
            let accountId = +this.route.snapshot.paramMap.get("accountId");
            this.tessadataService
                .getZoneGeometry(
                    event.coords.lng,
                    event.coords.lat,
                    currentMode.externalDatasetId,
                    accountId
                )
                .subscribe((geojson) => {
                    this.interactiveOverlayShapes.forEach(
                        (item) => (item.showInfo = false)
                    );
                    if (geojson) {
                        const color = this.getPolygonColorBasedOnZone(
                            geojson.properties.fld_zone
                        );
                        const style = {
                            fillColor: color,
                            strokeColor: color,
                            strokeWeight: 2,
                            fillOpacity: 0.5,
                            zIndex: -1,
                            stylers: null,
                        };
                        this.interactiveOverlayShapes.push({
                            geojson: geojson,
                            showInfo: true,
                            clickedLocation: event.coords,
                            style: style,
                        });
                        // this.externalDatasetShapeStyle.fillColor = color;
                        // this.externalDatasetShapeStyle.strokeColor = color;
                    }
                });
            return;
        }
        if (!this.isThematicMapEnabled) {
            infoWindow.open(this.mapElement.getZoom(), event.coords);
            this.clickedCoords = event.coords;
        } else {
            this.mapThematicOverlayService.onMapClick(
                this.mapElement.getZoom(),
                event.coords
            );
            this.mapThematicOverlayService.setMapCoords(
                this.mapElement.getZoom(),
                event.coords
            );
        }

        if (this.aerisMap) {
            this.aerisMap.setCenter({
                lat: event.coords.lat,
                lon: event.coords.lng,
            });
            this.aerisMap.setZoom(this.mapElement.getZoom());
        }
    }

    getPolygonColorBasedOnZone(floodZone: string) {
        let lightBlue = "#83b8e9";
        let blue = "#096099";
        let red = "#ca0202";
        let grey = "#aaaaaa";
        // if (floodZone.startsWith('X') || floodZone.startsWith('B') || floodZone.startsWith('C')) { return lightBlue; }
        // if (floodZone.startsWith('A')) { return blue; }
        // if (floodZone.startsWith('V')) { return red; }
        return lightBlue;
    }

    onMapRightClick(event: MouseEvent): void {
        if (this.isThematicMapEnabled) {
            this.mapThematicOverlayService.onMapRightClick();
        }
        switch (this.mapStatus.mode) {
            case MapInteractionMode.INTERACTION_DATASET_ACTIVE:
                this.interactiveOverlayShapes = [];
                break;
        }
    }

    clearMeasureShapes() {
        this.polygons.measure = [];
        this.polylines.measure = [];
        this.circles.measure = [];
        this.rectangles.measure = [];
    }

    clearSelectShapes() {
        this.resetLocks();
        this.polygons.select = [];
        this.circles.select = [];
        this.rectangles.select = [];
        
        // Clear custom circles (with 4 resize handles) when loading new filter
        this.clearAllCustomCircles();
        
        this.onGeometriesChange();
    }

    // DRAWING - legacy google.maps.drawing.DrawingManager path
    //
    // Commented out: DrawingManager was removed from the Maps JS API in v3.65.3b
    // and every shape is now captured in-house (see "In-house shape capture"),
    // so none of this can run. Kept rather than deleted until the migration is
    // signed off, since it is the reference for the original draw behaviour.
    //
    // onShapeOverlayComplete below stays LIVE - it is the handler the in-house
    // tools and the saved-filter replay both call into.
    // private addDrawingManager(state: MapState): void {
    //     if (!state.options.drawingMode) {
    //         return;
    //     }
    //     let color;
    //     if (state.options.drawingType === MapDrawType.FILTER) {
    //         color = shapeSelectColor;
    //         this.isMeasurementDrawing = false;
    //     } else {
    //         color = shapeMeasurementColor;
    //         this.isMeasurementDrawing = true;
    //     }
    //     if (!google.maps.drawing?.DrawingManager) {
    //         // Maps JS v3.65+ no longer ships the "drawing" library.
    //         this.notifService.error(
    //             'Shape drawing is unavailable on this version of Google Maps'
    //         );
    //         return;
    //     }

    //     let drawingMode = this.drawingManager?.getDrawingMode() ?? null;
    //     if (drawingMode === null) {
    //         this.drawingManager?.setDrawingMode(state.options.drawingMode);
    //     } else {
    //         this.drawingManager.setDrawingMode(null);
    //     }

    //     let config = {
    //         drawingControl: false,
    //         polygonOptions: {
    //             ...drawingOptions.polygon,
    //             fillColor: color,
    //             strokeColor: color,
    //         },
    //         polylineOptions: drawingOptions.polyline,
    //         circleOptions: {
    //             ...drawingOptions.circle,
    //             fillColor: color,
    //             strokeColor: color,
    //         },
    //         rectangleOptions: {
    //             ...drawingOptions.rectangle,
    //             fillColor: color,
    //             strokeColor: color,
    //         },
    //         drawingMode: state.options.drawingMode,
    //     };
    //     this.drawingManager = new google.maps.drawing.DrawingManager(config);
    //     this.drawingManager.setMap(this.mapElement);
    //     this.overlayCompleteListener = google.maps.event.addListener(
    //         this.drawingManager,
    //         "overlaycomplete",
    //         (overlay) => this.onShapeDrawComplete(overlay)
    //     );
    // }

    // private clearDrawingManager(): void {
    //     google.maps.event.removeListener(this.overlayCompleteListener);
    //     this.drawingManager?.setMap(null);
    //     this.drawingManager?.setDrawingMode(null);
    // }

    // private onShapeDrawComplete(
    //     event: google.maps.drawing.OverlayCompleteEvent
    // ): void {
    //     let overlay = event.overlay;
    //     this.onShapeOverlayComplete(event.type, overlay, true);
    //     overlay.setMap(null);
    //     this.clearDrawingManager();
    //     this.mapStateService.setDrawingMode(null, null);
    // }

    onShapeOverlayComplete(
        overlayType: OverlayType,
        overlay,
        updateFilter: boolean
    ) {
        // Compared against the local OverlayType enum: google.maps.drawing is
        // undefined on Maps JS v3.65+, and saved shape filters replay through
        // here on load, without the drawing tools ever being opened.
        switch (overlayType) {
            case OverlayType.CIRCLE:
                this.onCircleComplete(
                    overlay as google.maps.Circle,
                    updateFilter
                );
                break;
            case OverlayType.POLYGON:
                this.onPolygonComplete(
                    overlay as google.maps.Polygon,
                    updateFilter
                );
                break;
            case OverlayType.POLYLINE:
                this.onPolylineComplete(overlay as google.maps.Polyline);
                break;
            case OverlayType.RECTANGLE:
                this.onRectangleComplete(
                    overlay as google.maps.Rectangle,
                    updateFilter
                );
                break;
        }
    }

    onGeometriesBoundsChange(
        event: any,
        index: number,
        type: string,
        action: string
    ): void {
        this.cd.detectChanges();
        if (type === MapShape.CIRCLE) {
            if (action === this.MapDrawType.FILTER) {
                let circle = this.circles.select[index];
                // reset data earlier for markers to not remain to much on map
                circle.circleData = {};
                circle.isReceivingAllData = false;
                //
                circle.latitude = event.latitude;
                circle.longitude = event.longitude;
                circle.radius = event.radius;
                // this.fetchAerisApiDataWithinCircle(circle); // Commented out - Risk Info removed
            } else {
                let circle = this.circles.measure[index];
                circle.circleData = {};
                circle.emptyResponsesCounter = 0;
                circle.latitude = event.latitude;
                circle.longitude = event.longitude;
                circle.radius = event.radius;
                // this.fetchAerisApiDataWithinCircle(circle); // Commented out - Risk Info removed
            }
        } else if (type === MapShape.POLYGON) {
            if (action === this.MapDrawType.FILTER) {
                let polygon = this.polygons.select[index];
                // this.fetchAerisApiDataWithinPolygon(polygon); // Commented out - Risk Info removed
            } else {
                let polygon = this.polygons.measure[index];
                // this.fetchAerisApiDataWithinPolygon(polygon); // Commented out - Risk Info removed
            }
        } else {
            // Rectangles are the only shape whose stored bounds are rewritten from
            // the (boundsChange) event, so a bad event here silently corrupts the
            // geometry filter - and only for rectangles. The write is refused
            // unless the target exists and every edge is a finite number, so a
            // partial or undefined payload can no longer overwrite good bounds.
            const list =
                action === this.MapDrawType.FILTER
                    ? this.rectangles.select
                    : this.rectangles.measure;
            const rectangle = list?.[index];

            if (!rectangle || !this.hasFiniteBounds(event)) {
                return;
            }

            // agm-rectangle emits bounds_changed on first render with the bounds it
            // was just given. Rewriting identical values and refiring the filter
            // costs a tile refetch for nothing.
            const unchanged =
                rectangle.north === event.north &&
                rectangle.south === event.south &&
                rectangle.east === event.east &&
                rectangle.west === event.west;

            rectangle.rectangleData = {};
            rectangle.isReceivingAllData = false;
            rectangle.north = event.north;
            rectangle.east = event.east;
            rectangle.south = event.south;
            rectangle.west = event.west;
            // this.fetchAerisApiDataWithinRectangle(rectangle); // Commented out - Risk Info removed

            if (unchanged) {
                return;
            }
        }
        if (action === MapDrawType.FILTER) {
            this.onGeometriesChange();
        }
    }

    /** True when an agm bounds payload carries four usable edges. */
    private hasFiniteBounds(event: any): boolean {
        return (
            Number.isFinite(event?.north) &&
            Number.isFinite(event?.south) &&
            Number.isFinite(event?.east) &&
            Number.isFinite(event?.west)
        );
    }

    private onGeometriesChange(): void {
        // Extract custom circle data to include in filter
        const customCircleData = this.customCircles.map(item => item.data);

        // Update filter service with ALL shapes (template + custom circles)
        this.datapointsFilterService.updateShapes({
            rectangles: this.rectangles.select,
            circles: [...this.circles.select, ...customCircleData], // Include ALL circles (template + custom)
            polygons: this.polygons.select,
        });
    }

    onPolygonComplete(overlay: google.maps.Polygon, updateFilter: boolean) {
        const polygonObj: PolygonDrawing = {
            polygon: overlay,
        };
        const list = this.isMeasurementDrawing
            ? this.polygons.measure
            : this.polygons.select;
        list.push(polygonObj);
        
        // Initialize polygon state arrays for the new polygon
        if (!this.isMeasurementDrawing) {
            const newIndex = this.polygons.select.length - 1;
            this.polygonLocked[newIndex] = false;
            this.polygonMoveEnabled[newIndex] = false;
            this.polygons.select[newIndex].isEditable = true;
        }

        if (!this.isMeasurementDrawing && updateFilter) {
            this.analytics.trackEvent('select_polygon_filter_applied');
            this.onGeometriesChange();
            // this.fetchAerisApiDataWithinPolygon(polygonObj); // Commented out - Risk Info removed
        } else {
            this.analytics.trackEvent('measure_polygon_dimension_applied');
            // this.fetchAerisApiDataWithinPolygon(polygonObj); // Commented out - Risk Info removed
        }
    }

    fetchAerisApiDataWithinPolygon(polygon: PolygonDrawing) {
        polygon.isReceivingAllData = false;
        let coordinates = polygon.polygon
            .getPath()
            .getArray()
            .map((p) => [p.lat(), p.lng()]);
        let mergedCoords = [].concat.apply([], coordinates);
        let coordsApiParams = mergedCoords.toString();
        forkJoin([
            this.aerisService.fetchAerisDataWithinPolygon(
                AerisType.AIR_QUALITY,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                coordsApiParams,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinPolygon(
                AerisType.EARTHQUAKES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                coordsApiParams,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinPolygon(
                AerisType.FIRES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                coordsApiParams,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinPolygon(
                AerisType.CLIMATE_NORMALS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                coordsApiParams,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinPolygon(
                AerisType.OBSERVATIONS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                coordsApiParams,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinPolygon(
                AerisType.RIVERS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                coordsApiParams,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinPolygon(
                AerisType.RIVERS_GAUGES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                coordsApiParams,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinPolygon(
                AerisType.STORMCELLS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                coordsApiParams,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinPolygon(
                AerisType.STORM_REPORTS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                coordsApiParams,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinPolygon(
                AerisType.TIDES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                coordsApiParams,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinPolygon(
                AerisType.TROPICALCYCLONES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                coordsApiParams,
                FetchLimitParam.tropicalcyclonesLimit
            ),
            this.aerisService.fetchAerisDataWithinPolygon(
                AerisType.ALERTS_SUMMARY,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                coordsApiParams,
                FetchLimitParam.limit
            ),
            //,this.aerisService.fetchAerisDataWithinPolygon(AerisType.LIGHTNING_SUMMARY, coordsApiParams, FetchLimitParam.limit)
        ]).subscribe(
            ([
                airqualityObs,
                earthquakesObs,
                firesObs,
                normalsObs,
                observationsObs,
                riversObs,
                riversGaugesObs,
                stormcellsObs,
                stormReportsObs,
                tidesObs,
                tropicalcyclonesObs,
                alertsObs,
                lightningObs,
            ]) => {
                polygon.polygonData = {};
                polygon.polygonData = Object.assign(
                    this.prepareAirQualityResponse(airqualityObs),
                    this.prepareEarthquakesResponse(earthquakesObs),
                    this.prepareFiresResponse(firesObs),
                    this.prepareNormalsResponse(normalsObs),
                    this.prepareObservationsResponse(observationsObs),
                    this.prepareRiversResponse(riversObs),
                    this.prepareRiversGaugesResponse(riversGaugesObs),
                    this.prepareStormcellsResponse(stormcellsObs),
                    this.prepareStormreportsResponse(stormReportsObs),
                    this.prepareTidesResponse(tidesObs),
                    this.prepareTropicalcyclonesResponse(tropicalcyclonesObs),
                    this.prepareAlertsResponse(alertsObs),
                    this.prepareLightningResponse(lightningObs)
                );
            },
            (error) => {
                polygon.isReceivingAllData = true;
                polygon.emptyResponsesCounter =
                    numberOfAerisRequestsWithinShapes;
                this.notifService.error(
                    "We can not provide Risk Info for this type of polygon"
                );
                console.log(error);
            },
            () => {
                polygon.emptyResponsesCounter = 0;
                polygon.isReceivingAllData = true;
                polygon.emptyResponsesCounter = this.aerisResponsesCounter(
                    polygon.polygonData
                );
            }
        );
    }

    onCircleComplete(overlay: google.maps.Circle, updateFilter: boolean): void {
        const center = overlay.getCenter();
        const radius = overlay.getRadius();
        const list = this.isMeasurementDrawing
            ? this.circles.measure
            : this.circles.select;
        const circle: CircleDrawing = {
            radius: radius,
            latitude: center.lat(),
            longitude: center.lng(),
        };
        list.push(circle);
        if (!this.isMeasurementDrawing && updateFilter) {
            this.analytics.trackEvent('select_circle_filter_applied');
            this.onGeometriesChange();
            // this.fetchAerisApiDataWithinCircle(circle); // Commented out - Risk Info removed
        } else {
            this.analytics.trackEvent('measure_circle_dimension_applied');
            // this.fetchAerisApiDataWithinCircle(circle); // Commented out - Risk Info removed
        }
    }

    circleDragEnd(info: AgmInfoWindow) {
        // Info window will only open on click, not on drag end
        // setTimeout(() => {
        //     info.open();
        // }, 500);
    }

    // Helper methods to get top-right corner positions for info icon markers
    getCircleTopRight(circle: CircleDrawing): { lat: number; lng: number } {
        // Calculate top-right corner outside the circle
        // Radius is in meters, need to convert to degrees approximately
        const radiusInDegrees = circle.radius / 111320; // Rough conversion: 1 degree ≈ 111.32 km
        const fixedOffset = 0.0002; // ~22 meters, matching polygon logic
        const position = {
            lat: circle.latitude + radiusInDegrees + fixedOffset, // Just outside the edge of circle
            lng: circle.longitude + radiusInDegrees + fixedOffset
        };
        console.log('Circle icon position:', position, 'Circle center:', circle.latitude, circle.longitude, 'Radius in degrees:', radiusInDegrees);
        return position;
    }

    getRectangleTopRight(rectangle: RectangleDrawing): { lat: number; lng: number } {
        // Calculate top-right corner outside the rectangle
        const latOffset = (rectangle.north - rectangle.south) * 0.1;
        const lngOffset = (rectangle.east - rectangle.west) * 0.1;
        return {
            lat: rectangle.north + latOffset,
            lng: rectangle.east + lngOffset
        };
    }

    getPolygonTopRight(polygon: PolygonDrawing): { lat: number; lng: number } {
        // Create a unique cache key based on polygon path
        const path = polygon.polygon.getPath().getArray();
        const cacheKey = path.map(p => `${p.lat().toFixed(6)},${p.lng().toFixed(6)}`).join('|');
        
        // Check cache
        if (this.polygonIconPositionCache.has(cacheKey)) {
            return this.polygonIconPositionCache.get(cacheKey)!;
        }
        
        // Calculate bounding box and place icon at top-right
        if (path.length === 0) {
            return { lat: 0, lng: 0 };
        }
        
        let minLat = Infinity, maxLat = -Infinity;
        let minLng = Infinity, maxLng = -Infinity;
        
        path.forEach(point => {
            const lat = point.lat();
            const lng = point.lng();
            if (lat < minLat) minLat = lat;
            if (lat > maxLat) maxLat = lat;
            if (lng < minLng) minLng = lng;
            if (lng > maxLng) maxLng = lng;
        });
        
        // Use fixed small offset (~22 meters) instead of percentage-based offset
        // This prevents the icon from being placed far away for large polygons
        const fixedOffset = 0.0002;
        
        const result = {
            lat: maxLat + fixedOffset,
            lng: maxLng + fixedOffset
        };
        
        // Cache the result
        this.polygonIconPositionCache.set(cacheKey, result);
        
        return result;
    }

    // Keep center methods for reference if needed
    getCircleCenter(circle: CircleDrawing): { lat: number; lng: number } {
        return {
            lat: circle.latitude,
            lng: circle.longitude
        };
    }

    getRectangleCenter(rectangle: RectangleDrawing): { lat: number; lng: number } {
        return {
            lat: (rectangle.north + rectangle.south) / 2,
            lng: (rectangle.east + rectangle.west) / 2
        };
    }

    getPolygonCenter(polygon: PolygonDrawing): { lat: number; lng: number } {
        const path = polygon.polygon.getPath().getArray();
        if (path.length === 0) {
            return { lat: 0, lng: 0 };
        }
        
        let latSum = 0;
        let lngSum = 0;
        path.forEach(point => {
            latSum += point.lat();
            lngSum += point.lng();
        });
        
        return {
            lat: latSum / path.length,
            lng: lngSum / path.length
        };
    }

    // Icon click handlers to open info windows
    onCircleIconClick(index: number) {
        const infoWindow = this.infoWindows.toArray()[index];
        if (infoWindow) {
            infoWindow.open();
        }
    }

    onRectangleIconClick(index: number) {
        const infoWindow = this.infoWindows.toArray()[this.circles.select.length + index];
        if (infoWindow) {
            infoWindow.open();
        }
    }

    // Store original rectangle position when drag starts
    private rectangleDragStartPosition: { lat: number; lng: number } | null = null;

    onRectangleIconDragStart(index: number) {
        const rectangle = this.rectangles.select[index];
        if (rectangle) {
            // Calculate the current top-right position (icon position)
            const topRight = this.getRectangleTopRight(rectangle);
            this.rectangleDragStartPosition = topRight;
        }
    }

    onRectangleIconDrag(event: any, index: number) {
        const rectangle = this.rectangles.select[index];
        if (!rectangle || !this.rectangleDragStartPosition) {
            return;
        }

        // Calculate the offset between old and new icon position
        const newIconLat = event.coords.lat;
        const newIconLng = event.coords.lng;
        const latOffset = newIconLat - this.rectangleDragStartPosition.lat;
        const lngOffset = newIconLng - this.rectangleDragStartPosition.lng;

        // Move rectangle bounds by the same offset
        rectangle.north += latOffset;
        rectangle.south += latOffset;
        rectangle.east += lngOffset;
        rectangle.west += lngOffset;

        // Update the drag start position for next drag event
        this.rectangleDragStartPosition = { lat: newIconLat, lng: newIconLng };
    }

    onRectangleIconDragEnd(event: any, index: number) {
        // Rectangle has already been updated during drag events
        // Just need to update the filter and clean up
        
        // Update the filter with the new rectangle position
        this.onGeometriesChange();

        // Clear the drag start position
        this.rectangleDragStartPosition = null;
    }

    onPolygonIconClick(index: number) {
        const infoWindow = this.infoWindows.toArray()[this.circles.select.length + this.rectangles.select.length + index];
        if (infoWindow) {
            infoWindow.open();
        }
    }

    onPolygonIconRightClick(index: number) {
        // Toggle rotation mode for the polygon
        if (this.polygonLocked[index]) {
            // Unlock polygon - exit rotation mode
            this.unlockPolygon(index);
        } else {
            // Lock polygon - enter rotation mode
            // Get the first vertex as the rotation pivot
            const polygonDrawing = this.polygons.select[index];
            if (polygonDrawing && polygonDrawing.polygon) {
                const path = polygonDrawing.polygon.getPath().getArray();
                if (path.length > 0) {
                    this.vertexInfoLat = path[0].lat();
                    this.vertexInfoLng = path[0].lng();
                    this.selectedPolygonIndex = index;
                    this.selectedVertexIndex = 0;
                    this.lockPolygon(index);
                }
            }
        }
    }

    // Store original polygon position when drag starts
    private polygonDragStartPosition: { lat: number; lng: number } | null = null;

    // Cache for polygon icon positions to prevent repeated calculations
    private polygonIconPositionCache: Map<string, { lat: number; lng: number }> = new Map();

    onPolygonIconDragStart(index: number) {
        const polygonDrawing = this.polygons.select[index];
        if (polygonDrawing && polygonDrawing.polygon) {
            // Calculate the current top-right position (icon position)
            const topRight = this.getPolygonTopRight(polygonDrawing);
            this.polygonDragStartPosition = topRight;

            // If rotation mode is enabled, initialize rotation session
            if (this.polygonLocked[index] && !this.rotating[index]) {
                this.rotating[index] = true;
                this.undoAvailable[index] = true;
                
                // Initialize rotationBaseCoords with current polygon coordinates
                const path = polygonDrawing.polygon.getPath().getArray();
                this.rotationBaseCoords[index] = path.map(p => ({
                    lat: p.lat(),
                    lng: p.lng()
                }));
                
                const startPt = { lat: topRight.lat, lng: topRight.lng };
                this.rotationSessionStartAngle[index] = this.computeAngle(startPt, this.lockedVertexCoords[index]!);
                this.rotationSessionBaseCoords[index] = this.rotationBaseCoords[index].map(c => ({ ...c }));
                this.rotationAngles[index] = 0;
            }
        }
    }

    onPolygonIconDrag(event: any, index: number) {
        const polygonDrawing = this.polygons.select[index];
        if (!polygonDrawing || !polygonDrawing.polygon || !this.polygonDragStartPosition) {
            return;
        }

        // Check if rotation mode is enabled
        if (this.polygonLocked[index]) {
            // Rotate the polygon around the locked vertex
            this.rotatePolygonAroundLockedVertex(index, event);
            return;
        }

        // Otherwise, move the entire polygon
        // Calculate the offset between old and new icon position
        const newIconLat = event.coords.lat;
        const newIconLng = event.coords.lng;
        const latOffset = newIconLat - this.polygonDragStartPosition.lat;
        const lngOffset = newIconLng - this.polygonDragStartPosition.lng;

        // Get the polygon's path
        const path = polygonDrawing.polygon.getPath();
        const pathArray = path.getArray();

        // Move all polygon vertices by the same offset
        const newPath = pathArray.map(point => {
            return new google.maps.LatLng(
                point.lat() + latOffset,
                point.lng() + lngOffset
            );
        });

        // Update the polygon's path with new coordinates
        path.clear();
        newPath.forEach(point => path.push(point));

        // Clear cache since polygon has changed
        this.polygonIconPositionCache.clear();

        // Update the drag start position for next drag event
        this.polygonDragStartPosition = { lat: newIconLat, lng: newIconLng };
    }

    onPolygonIconDragEnd(event: any, index: number) {
        // Polygon has already been updated during drag events
        // Just need to update the filter and clean up

        // Ensure polygon remains editable so vertices stay visible
        if (this.polygons.select[index]) {
            this.polygons.select[index].isEditable = true;

            // Update shapeCoords to reflect the new polygon position
            const polygonDrawing = this.polygons.select[index];
            const path = polygonDrawing.polygon.getPath().getArray();
            this.shapeCoords[index] = path.map(p => ({
                lat: this.roundCoord(p.lat()),
                lng: this.roundCoord(p.lng())
            }));

            // If rotation mode was enabled, clean up rotation state
            if (this.polygonLocked[index] && this.isRotating[index]) {
                this.rotating[index] = false;
                this.isRotating[index] = false;
                this.lastDragPoint[index] = null;
            }
        }

        // Clear drag start position
        this.polygonDragStartPosition = null;

        this.onGeometriesChange();
    }

    fetchAerisApiDataWithinCircle(circle: CircleDrawing) {
        let radiusInMi = this.mToMi(circle.radius);
        circle.isReceivingAllData = false;
        forkJoin([
            this.aerisService.fetchAerisDataWithinCircle(
                AerisType.AIR_QUALITY,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                circle.latitude,
                circle.longitude,
                radiusInMi,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinCircle(
                AerisType.EARTHQUAKES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                circle.latitude,
                circle.longitude,
                radiusInMi,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinCircle(
                AerisType.FIRES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                circle.latitude,
                circle.longitude,
                radiusInMi,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinCircle(
                AerisType.CLIMATE_NORMALS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                circle.latitude,
                circle.longitude,
                radiusInMi,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinCircle(
                AerisType.OBSERVATIONS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                circle.latitude,
                circle.longitude,
                radiusInMi,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinCircle(
                AerisType.RIVERS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                circle.latitude,
                circle.longitude,
                radiusInMi,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinCircle(
                AerisType.RIVERS_GAUGES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                circle.latitude,
                circle.longitude,
                radiusInMi,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinCircle(
                AerisType.STORMCELLS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                circle.latitude,
                circle.longitude,
                radiusInMi,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinCircle(
                AerisType.STORM_REPORTS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                circle.latitude,
                circle.longitude,
                radiusInMi,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinCircle(
                AerisType.TIDES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                circle.latitude,
                circle.longitude,
                radiusInMi,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinCircle(
                AerisType.TROPICALCYCLONES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                circle.latitude,
                circle.longitude,
                radiusInMi,
                FetchLimitParam.tropicalcyclonesLimit
            ),
            this.aerisService.fetchAerisDataWithinCircle(
                AerisType.ALERTS_SUMMARY,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                circle.latitude,
                circle.longitude,
                radiusInMi,
                FetchLimitParam.limit
            ),
            //,this.aerisService.fetchAerisDataWithinCircle(AerisType.LIGHTNING_SUMMARY, circle.latitude, circle.longitude, radiusInMi, FetchLimitParam.limit)
        ]).subscribe(
            ([
                airqualityObs,
                earthquakesObs,
                firesObs,
                normalsObs,
                observationsObs,
                riversObs,
                riversGaugesObs,
                stormcellsObs,
                stormReportsObs,
                tidesObs,
                tropicalcyclonesObs,
                alertsObs,
                lightningObs,
            ]) => {
                circle.circleData = {};
                circle.circleData = Object.assign(
                    this.prepareAirQualityResponse(airqualityObs),
                    this.prepareEarthquakesResponse(earthquakesObs),
                    this.prepareFiresResponse(firesObs),
                    this.prepareNormalsResponse(normalsObs),
                    this.prepareObservationsResponse(observationsObs),
                    this.prepareRiversResponse(riversObs),
                    this.prepareRiversGaugesResponse(riversGaugesObs),
                    this.prepareStormcellsResponse(stormcellsObs),
                    this.prepareStormreportsResponse(stormReportsObs),
                    this.prepareTidesResponse(tidesObs),
                    this.prepareTropicalcyclonesResponse(tropicalcyclonesObs),
                    this.prepareAlertsResponse(alertsObs),
                    this.prepareLightningResponse(lightningObs)
                );
            },
            (error) => {
                circle.isReceivingAllData = true;
                circle.emptyResponsesCounter =
                    numberOfAerisRequestsWithinShapes;
                this.notifService.error(
                    "Something went wrong... We can not provide Risk Info"
                );
                console.log(error);
            },
            () => {
                circle.emptyResponsesCounter = 0;
                circle.isReceivingAllData = true;
                circle.emptyResponsesCounter = this.aerisResponsesCounter(
                    circle.circleData
                );
            }
        );
    }

    aerisResponsesCounter(data: object) {
        let lists = Object.values(data);
        let counter = 0;
        lists.forEach((list) => {
            if (list.length === 0) {
                counter++;
            }
        });
        return counter;
    }

    showCircleInfoByLabel(data: any) {
        data.showData = !data.showData;
    }

    prepareAirQualityResponse(list: any): ObjAerisType {
        // prepare array with unique loc and lng
        for (let i = 0; i < list.response.length; i++) {
            if (list.response[i] !== undefined && list[i + 1] !== undefined) {
                if (list.response[i].loc.lat === list.response[i + 1].loc.lat) {
                    list.splice(i, 1);
                    i--;
                }
            }
        }
        let airqualityList = [];
        list.response.forEach((item) => {
            let propertiesPicked = {};
            let pollutantsList = [];
            if (item.periods) {
                propertiesPicked = (({
                    category,
                    dateTimeISO,
                    dominant,
                    method,
                }) => ({ category, dateTimeISO, dominant, method }))(
                    item.periods[0]
                );
                item.periods[0].pollutants.forEach((pollutant) => {
                    let pollutantPropertiesPicked = (({
                        name,
                        category,
                        valuePPB,
                        valueUGM3,
                    }) => ({ name, category, valuePPB, valueUGM3 }))(pollutant);
                    let prepareDisplayedPollutantsList = Object.entries(
                        pollutantPropertiesPicked
                    );
                    pollutantsList.push(prepareDisplayedPollutantsList);
                });
            }
            let preparedPickedProperties = Object.entries(propertiesPicked);
            let airQualityObj = {
                type: this.AerisType.AIR_QUALITY,
                loc: item.loc,
                properties: preparedPickedProperties,
                traitLabel: "Pollutant",
                traitList: pollutantsList,
                description: this.AerisDescriptions.AIR_QUALITY,
                showData: false,
            };
            airqualityList.push(airQualityObj);
        });
        let airquality: ObjAerisType = {};
        airquality[AerisType.AIR_QUALITY] = airqualityList;
        return airquality;
    }

    prepareEarthquakesResponse(list: any): ObjAerisType {
        let earthquakesList = [];
        list.response.forEach((item: any) => {
            let propertiesPicked = {};
            if (item.report) {
                propertiesPicked = (({
                    region,
                    dateTimeISO,
                    updatedDateTimeISO,
                    type,
                    depthKM,
                    mag,
                }) => ({
                    region,
                    dateTimeISO,
                    updatedDateTimeISO,
                    type,
                    depthKM,
                    mag,
                }))(item.report);
            }
            let preparedPickedProperties = Object.entries(propertiesPicked);
            let earthquakesObj = {
                type: this.AerisType.EARTHQUAKES,
                loc: item.loc,
                properties: preparedPickedProperties,
                description: AerisDescriptions.EARTHQUAKES,
                showData: false,
            };
            earthquakesList.push(earthquakesObj);
        });
        let earthquakes: ObjAerisType = {};
        earthquakes[AerisType.EARTHQUAKES] = earthquakesList;
        return earthquakes;
    }

    prepareFiresResponse(list: any): ObjAerisType {
        let firesList = [];
        list.response.forEach((item: any) => {
            let propertiesPicked = {};
            if (item.report) {
                propertiesPicked = (({
                    dateTimeISO,
                    starDateISO,
                    cause,
                    areaKM,
                    fuels,
                    location,
                    terrain,
                }) => ({
                    dateTimeISO,
                    starDateISO,
                    cause,
                    areaKM,
                    fuels,
                    location,
                    terrain,
                }))(item.report);
            }
            let preparedPickedProperties = Object.entries(propertiesPicked);
            let firesObj = {
                type: this.AerisType.FIRES,
                loc: item.loc,
                properties: preparedPickedProperties,
                description: AerisDescriptions.FIRES,
                shoWData: false,
            };
            firesList.push(firesObj);
        });
        let fires: ObjAerisType = {};
        fires[AerisType.FIRES] = firesList;
        return fires;
    }

    prepareNormalsResponse(list: any): ObjAerisType {
        let normalsList = [];
        list.response.forEach((item: any) => {
            // daily - default - periods[0]
            let propertiesPicked = {};
            if (item.periods) {
                let generalProperties = (({ dateTimeISO, type }) => ({
                    dateTimeISO,
                    type,
                }))(item.periods[0]);
                let tempProperties = item.periods[0].temp;
                propertiesPicked = { ...generalProperties, ...tempProperties };
            }
            let preparedPickedProperties = Object.entries(propertiesPicked);
            let normalsObj = {
                type: this.AerisType.CLIMATE_NORMALS,
                loc: item.loc,
                properties: preparedPickedProperties,
                description: AerisDescriptions.CLIMATE_NORMALS,
                showData: false,
            };
            normalsList.push(normalsObj);
        });
        let normals: ObjAerisType = {};
        normals[AerisType.CLIMATE_NORMALS] = normalsList;
        return normals;
    }

    prepareObservationsResponse(list: any): ObjAerisType {
        let observationsList = [];
        list.response.forEach((item: any) => {
            let obsPropertiesPicked = {};
            let generalProperties = {};
            if (item.dataSource) {
                generalProperties = (({ dataSource }) => ({ dataSource }))(
                    item
                );
            }
            if (item.ob) {
                obsPropertiesPicked = (({
                    dateTimeISO,
                    feelslikeC,
                    humidity,
                    heatindexC,
                    recDateTimeISO,
                    solradMethod,
                    tempC,
                    weather,
                    windDir,
                    windSpeedKPH,
                    windGustKPH,
                }) => ({
                    dateTimeISO,
                    feelslikeC,
                    humidity,
                    heatindexC,
                    recDateTimeISO,
                    solradMethod,
                    tempC,
                    weather,
                    windDir,
                    windSpeedKPH,
                    windGustKPH,
                }))(item.ob);
            }
            let propertiesPicked = {
                ...generalProperties,
                ...obsPropertiesPicked,
            };
            let preparedPickedProperties = Object.entries(propertiesPicked);
            let observationsObj = {
                type: this.AerisType.OBSERVATIONS,
                loc: item.loc,
                properties: preparedPickedProperties,
                description: AerisDescriptions.OBSERVATIONS,
                showData: false,
            };
            observationsList.push(observationsObj);
        });
        let observations: ObjAerisType = {};
        observations[AerisType.OBSERVATIONS] = observationsList;
        return observations;
    }

    prepareRiversResponse(list: any): ObjAerisType {
        let riversList = [];
        list.response.forEach((item: any) => {
            let propertiesPicked = {};
            if (item.ob) {
                propertiesPicked = (({
                    dateTimeISO,
                    heightM,
                    flowCMS,
                    status,
                    impact,
                }) => ({ dateTimeISO, heightM, flowCMS, status, impact }))(
                    item.ob
                );
            }
            let preparedPickedProperties = Object.entries(propertiesPicked);
            let riversObj = {
                type: this.AerisType.RIVERS,
                loc: item.loc,
                properties: preparedPickedProperties,
                description: AerisDescriptions.RIVERS,
                showData: false,
            };
            riversList.push(riversObj);
        });
        let rivers: ObjAerisType = {};
        rivers[AerisType.RIVERS] = riversList;
        return rivers;
    }

    prepareRiversGaugesResponse(list: any): ObjAerisType {
        let riversGaugesList = [];
        list.response.forEach((item: any) => {
            let propertiesPicked = {};
            let preparedPickedProperties;
            let impacts = [];
            if (item.profile) {
                if (item.profile.cats) {
                    propertiesPicked = (({
                        actionM,
                        floodM,
                        majorM,
                        moderateM,
                    }) => ({ actionM, floodM, majorM, moderateM }))(
                        item.profile.cats
                    );
                }
                if (item.profile.waterbody) {
                    propertiesPicked["waterbody"] = item.profile.waterbody;
                }
                preparedPickedProperties = Object.entries(propertiesPicked);
                let impactsProp;
                let impatcsExists = item.profile.hasOwnProperty("impacts");
                if (impatcsExists) {
                    if (item.profile.impacts) {
                        item.profile.impacts.forEach((impact) => {
                            impactsProp = Object.entries(impact);
                            impacts.push(impactsProp);
                        });
                    }
                }
            }
            let riversGaugesObj = {
                type: this.AerisType.RIVERS_GAUGES,
                loc: item.loc,
                properties: preparedPickedProperties,
                traitLabel: "Impact",
                traitList: impacts || null,
                description: AerisDescriptions.RIVERS_GAUGES,
                showData: false,
            };
            riversGaugesList.push(riversGaugesObj);
        });
        let riversGauges: ObjAerisType = {};
        riversGauges[AerisType.RIVERS_GAUGES] = riversGaugesList;
        return riversGauges;
    }

    prepareStormcellsResponse(list: any): ObjAerisType {
        let stormcellsList = [];
        list.response.forEach((item: any) => {
            let propertiesPicked = {};
            if (item.ob) {
                propertiesPicked = (({ dateTimeISO, location }) => ({
                    dateTimeISO,
                    location,
                }))(item.ob);
            }
            let preparedPickedProperties = Object.entries(propertiesPicked);
            let traits;
            if (item.traits) {
                traits = Object.entries(item.traits);
            }
            let stormcellsObj = {
                type: this.AerisType.STORMCELLS,
                loc: item.loc,
                properties: preparedPickedProperties,
                traitLabel: "Traits",
                traitList: traits || null,
                description: AerisDescriptions.STORMCELLS,
                showData: false,
            };
            stormcellsList.push(stormcellsObj);
        });
        let stormcells: ObjAerisType = {};
        stormcells[AerisType.STORMCELLS] = stormcellsList;
        return stormcells;
    }

    prepareStormreportsResponse(list: any): ObjAerisType {
        let stormreportsList = [];
        list.response.forEach((item: any) => {
            let propertiesPicked = {};
            if (item.report) {
                propertiesPicked = (({
                    dateTimeISO,
                    cat,
                    comments,
                    type,
                    reporter,
                    name,
                }) => ({ dateTimeISO, cat, comments, type, reporter, name }))(
                    item.report
                );
            }
            const preparedPickedProperties = Object.entries(propertiesPicked);
            let stormreportsObj = {
                type: this.AerisType.STORM_REPORTS,
                loc: item.loc,
                properties: preparedPickedProperties,
                description: AerisDescriptions.STORM_REPORTS,
                showData: false,
            };
            stormreportsList.push(stormreportsObj);
        });
        let stormreports: ObjAerisType = {};
        stormreports[AerisType.STORM_REPORTS] = stormreportsList;
        return stormreports;
    }

    prepareTidesResponse(list: any): ObjAerisType {
        let tidesList = [];
        list.response.forEach((item: any) => {
            let propertiesPicked = {};
            if (item.periods) {
                propertiesPicked = (({
                    dateTimeISO,
                    heightM,
                    heightFT,
                    type,
                }) => ({ dateTimeISO, heightM, heightFT, type }))(
                    item.periods[0]
                );
            }
            let preparedPickedProperties = Object.entries(propertiesPicked);
            let tidesObj = {
                type: this.AerisType.TIDES,
                loc: item.loc,
                properties: preparedPickedProperties || null,
                description: AerisDescriptions.TIDES,
                showData: false,
            };
            tidesList.push(tidesObj);
        });
        let tides: ObjAerisType = {};
        tides[AerisType.TIDES] = tidesList;
        return tides;
    }

    prepareTropicalcyclonesResponse(list: any): ObjAerisType {
        let tropicalcyclonesList = [];
        list.response.forEach((item: any) => {
            let propertiesPicked = {};
            let movementPrepared;
            if (item.position) {
                let generalInfoPicked = (({ dateTimeISO }) => ({
                    dateTimeISO,
                }))(item.position);
                if (item.position.details) {
                    let detailsPicked = (({
                        stormName,
                        stormType,
                        advisoryNumber,
                        windSpeedKTS,
                        gustSpeedKTS,
                        pressureMB,
                        basin,
                    }) => ({
                        stormName,
                        stormType,
                        advisoryNumber,
                        windSpeedKTS,
                        gustSpeedKTS,
                        pressureMB,
                        basin,
                    }))(item.position.details);
                    let movement = item.position.details.movement;
                    movementPrepared = Object.entries(movement);
                    propertiesPicked = {
                        ...generalInfoPicked,
                        ...detailsPicked,
                    };
                }
            }
            let preparedPickedProperties = Object.entries(propertiesPicked);
            let tropicalcyclonesObj = {
                type: this.AerisType.TROPICALCYCLONES,
                properties: preparedPickedProperties,
                loc: item.position.loc,
                traitLabel: "Movement",
                traitList: movementPrepared,
                description: AerisDescriptions.TROPICALCYCLONES,
                showData: false,
            };
            tropicalcyclonesList.push(tropicalcyclonesObj);
        });
        let tropicalcyclones: ObjAerisType = {};
        tropicalcyclones[AerisType.TROPICALCYCLONES] = tropicalcyclonesList;
        return tropicalcyclones;
    }

    prepareAlertsResponse(response: any): ObjAerisType {
        let alertsTypesPicked;
        let alertsList = [];
        if (response !== undefined && response.response.length > 0) {
            alertsTypesPicked = (({ types }) => ({ types }))(
                response.response[0].summary
            );
            let propertiesPicked = [];
            alertsTypesPicked.types.forEach((alert) => {
                alert.countries = alert.countries.toString();
                let alertPropertiesPicked = (({
                    type,
                    countries,
                    priority,
                    count,
                }) => ({ type, countries, priority, count }))(alert);
                let preparedPickedProperties = Object.entries(
                    alertPropertiesPicked
                );
                propertiesPicked.push(preparedPickedProperties);
            });
            let alertsObj = {
                type: this.AerisType.ALERTS_SUMMARY,
                properties: propertiesPicked || null,
                description: this.AerisDescriptions.ALERTS_SUMMARY,
                showData: false,
            };
            alertsList.push(alertsObj);
        }
        let alerts: ObjAerisType = {};
        alerts[AerisType.ALERTS_SUMMARY] = alertsList;
        return alerts;
    }

    prepareLightningResponse(response: any): ObjAerisType {
        let lightningRange = {};
        let lightningPulse = {};
        let lightningList = [];
        if (response !== undefined && response.response.length > 0) {
            lightningRange = (({ count, minDateTimeISO, maxDateTimeISO }) => ({
                count,
                minDateTimeISO,
                maxDateTimeISO,
            }))(response.response[0].summary.range);
            let prepareLightningRange = Object.entries(lightningRange);
            lightningPulse = (({ count, cg, ic, negative, positive }) => ({
                count,
                cg,
                ic,
                negative,
                positive,
            }))(response.response[0].summary.pulse);
            let prepareLightningPulse = Object.entries(lightningPulse);
            let lightningObj = {
                type: this.AerisType.LIGHTNING_SUMMARY,
                range: prepareLightningRange,
                pulse: prepareLightningPulse,
                description: this.AerisDescriptions.LIGHTNING_SUMMARY,
                showData: false,
            };
            lightningList.push(lightningObj);
        }
        let lightning: ObjAerisType = {};
        lightning[AerisType.LIGHTNING_SUMMARY] = lightningList;
        return lightning;
    }

    get AerisType() {
        return AerisType;
    }

    get AerisDescriptions() {
        return AerisDescriptions;
    }

    get numberOfAerisRequestsWithinShapes() {
        return numberOfAerisRequestsWithinShapes;
    }

    onRectangleComplete(
        overlay: google.maps.Rectangle,
        updateFilter: boolean
    ): void {
        const bounds = overlay.getBounds();
        const list = this.isMeasurementDrawing
            ? this.rectangles.measure
            : this.rectangles.select;
        const rectangle: RectangleDrawing = {
            north: bounds.getNorthEast().lat(),
            south: bounds.getSouthWest().lat(),
            east: bounds.getNorthEast().lng(),
            west: bounds.getSouthWest().lng(),
        };
        list.push(rectangle);

        if (!this.isMeasurementDrawing && updateFilter) {
            this.analytics.trackEvent('select_rectangle_filter_applied');
            this.onGeometriesChange();
            // this.fetchAerisApiDataWithinRectangle(rectangle); // Commented out - Risk Info removed
        } else {
            this.analytics.trackEvent('measure_rectangle_dimension_applied');
            // this.fetchAerisApiDataWithinRectangle(rectangle); // Commented out - Risk Info removed
        }
    }

    fetchAerisApiDataWithinRectangle(rectangle: RectangleDrawing) {
        rectangle.isReceivingAllData = false;
        forkJoin([
            this.aerisService.fetchAerisDataWithinRectangle(
                AerisType.AIR_QUALITY,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                rectangle.north,
                rectangle.west,
                rectangle.south,
                rectangle.east,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinRectangle(
                AerisType.EARTHQUAKES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                rectangle.north,
                rectangle.west,
                rectangle.south,
                rectangle.east,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinRectangle(
                AerisType.FIRES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                rectangle.north,
                rectangle.west,
                rectangle.south,
                rectangle.east,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinRectangle(
                AerisType.CLIMATE_NORMALS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                rectangle.north,
                rectangle.west,
                rectangle.south,
                rectangle.east,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinRectangle(
                AerisType.OBSERVATIONS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                rectangle.north,
                rectangle.west,
                rectangle.south,
                rectangle.east,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinRectangle(
                AerisType.RIVERS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                rectangle.north,
                rectangle.west,
                rectangle.south,
                rectangle.east,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinRectangle(
                AerisType.RIVERS_GAUGES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                rectangle.north,
                rectangle.west,
                rectangle.south,
                rectangle.east,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinRectangle(
                AerisType.STORMCELLS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                rectangle.north,
                rectangle.west,
                rectangle.south,
                rectangle.east,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinRectangle(
                AerisType.STORM_REPORTS,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                rectangle.north,
                rectangle.west,
                rectangle.south,
                rectangle.east,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinRectangle(
                AerisType.TIDES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                rectangle.north,
                rectangle.west,
                rectangle.south,
                rectangle.east,
                FetchLimitParam.limit
            ),
            this.aerisService.fetchAerisDataWithinRectangle(
                AerisType.TROPICALCYCLONES,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                rectangle.north,
                rectangle.west,
                rectangle.south,
                rectangle.east,
                FetchLimitParam.tropicalcyclonesLimit
            ),
            this.aerisService.fetchAerisDataWithinRectangle(
                AerisType.ALERTS_SUMMARY,
                this.aerisCredentials.aerisClient,
                this.aerisCredentials.aerisSecret,
                rectangle.north,
                rectangle.west,
                rectangle.south,
                rectangle.east,
                FetchLimitParam.limit
            ),
            //,this.aerisService.fetchAerisDataWithinRectangle(AerisType.LIGHTNING_SUMMARY, rectangle.north, rectangle.west, rectangle.south, rectangle.east, FetchLimitParam.limit)
        ]).subscribe(
            ([
                airqualityObs,
                earthquakesObs,
                firesObs,
                normalsObs,
                observationsObs,
                riversObs,
                riversGaugesObs,
                stormcellsObs,
                stormReportsObs,
                tidesObs,
                tropicalcyclonesObs,
                alertsObs,
                lightningObs,
            ]) => {
                rectangle.rectangleData = {};
                rectangle.rectangleData = Object.assign(
                    this.prepareAirQualityResponse(airqualityObs),
                    this.prepareEarthquakesResponse(earthquakesObs),
                    this.prepareFiresResponse(firesObs),
                    this.prepareNormalsResponse(normalsObs),
                    this.prepareObservationsResponse(observationsObs),
                    this.prepareRiversResponse(riversObs),
                    this.prepareRiversGaugesResponse(riversGaugesObs),
                    this.prepareStormcellsResponse(stormcellsObs),
                    this.prepareStormreportsResponse(stormReportsObs),
                    this.prepareTidesResponse(tidesObs),
                    this.prepareTropicalcyclonesResponse(tropicalcyclonesObs),
                    this.prepareAlertsResponse(alertsObs),
                    this.prepareLightningResponse(lightningObs)
                );
            },
            (error) => {
                rectangle.isReceivingAllData = true;
                rectangle.emptyResponsesCounter =
                    numberOfAerisRequestsWithinShapes;
                this.notifService.error(
                    "Something went wrong... We can not provide Risk Info"
                );
                console.log(error);
            },
            () => {
                rectangle.emptyResponsesCounter = 0;
                rectangle.isReceivingAllData = true;
                rectangle.emptyResponsesCounter = this.aerisResponsesCounter(
                    rectangle.rectangleData
                );
            }
        );
    }

    onPolylineComplete(overlay: google.maps.Polyline) {
        let path = overlay.getPath().getArray();
        const polylineObj: PolylineDrawing = {
            polyline: path as google.maps.LatLng[],
            latPolylineInfobox: path[0].lat(),
            lngPolylineInfobox: path[0].lng(),
        };
        this.analytics.trackEvent('measure_polyline_dimension_applied');
        this.polylines.measure.push(polylineObj);
    }

    getLastCoordsForInfobox(event, i, info: AgmInfoWindow) {
        let point = { lat: event.latLng.lat(), lng: event.latLng.lng() };
        this.polylines.measure[i].latPolylineInfobox = point.lat;
        this.polylines.measure[i].lngPolylineInfobox = point.lng;
        // Info window will only open on click, not on drag end
        // info.open();
    }

    /**
     * Task 3: Enter circle placement mode
     * Adds map click listener and changes cursor
     */
    private enterCirclePlacementMode(): void {
        if (this.isInCirclePlacementMode || !this.mapElement) {
            return;
        }
        
        this.isInCirclePlacementMode = true;
        
        // Change cursor to crosshair
        this.mapElement.setOptions({ draggableCursor: 'crosshair' });
        
        // Disable map panning temporarily
        this.mapElement.setOptions({ draggable: false });
        
        // Add click listener for circle placement
        this.circlePlacementClickListener = this.mapElement.addListener('click', (event: any) => {
            this.onMapClickForCirclePlacement(event);
        });
        
    }
    
    /**
     * Task 3: Exit circle placement mode
     * Removes map click listener and restores cursor
     */
    private exitCirclePlacementMode(): void {
        if (!this.isInCirclePlacementMode) {
            return;
        }
        
        this.isInCirclePlacementMode = false;
        
        // Remove click listener
        if (this.circlePlacementClickListener) {
            google.maps.event.removeListener(this.circlePlacementClickListener);
            this.circlePlacementClickListener = null;
        }
        
        // Restore default cursor
        if (this.mapElement) {
            this.mapElement.setOptions({ draggableCursor: null });

            // Re-enable map panning
            this.mapElement.setOptions({ draggable: true });
        }
    }

    // =====================================================================
    // In-house shape capture
    //
    // Replaces google.maps.drawing.DrawingManager, which Google removed in Maps
    // JS API v3.65. Every tool captures from plain map events and then hands the
    // finished overlay to the existing onXComplete handler, so filtering,
    // editing and persistence downstream are unchanged.
    //
    // The four tools reduce to two gestures:
    //
    //   drag   (rectangle, circle)  mousedown -> mousemove -> mouseup
    //   vertex (polygon, polyline)  click per point, dblclick/Enter to finish
    //
    // so they share one session object and one set of handlers, parameterised by
    // kind. Each session also carries its MapDrawType: FILTER for a Select shape
    // that filters datapoints, MEASURE for one that only reports area/distance.
    // =====================================================================

    /** Set true to log every committed shape while debugging capture problems. */
    private static readonly DRAW_DEBUG = false;

    private drawSession: DrawSession | null = null;

    /** Screen-pixel radius around the first vertex that counts as closing a ring. */
    private readonly VERTEX_CLOSE_PIXEL_RADIUS = 14;
    private readonly RECTANGLE_DRAG_MIN_DIAGONAL_METERS = 50;
    private readonly CIRCLE_DRAG_MIN_RADIUS_METERS = 50;

    /** Minimum points before a vertex shape can be committed. */
    private readonly MIN_VERTICES: Record<VertexDrawKind, number> = {
        polygon: 3,
        polyline: 2
    };

    // ------------------------------------------------------------- entry points

    private enterRectangleDrawMode(target: MapDrawType = MapDrawType.FILTER): void {
        this.beginDragSession('rectangle', target);
    }

    private exitRectangleDrawMode(): void {
        this.endDrawSession('rectangle');
    }

    private enterCircleDragDrawMode(target: MapDrawType = MapDrawType.MEASURE): void {
        this.beginDragSession('circle', target);
    }

    private exitCircleDragDrawMode(): void {
        this.endDrawSession('circle');
    }

    private enterPolygonDrawMode(target: MapDrawType = MapDrawType.FILTER): void {
        this.beginVertexSession(
            'polygon',
            target,
            'Click to add points. Click the first point (or double-click) to finish, Esc to cancel.'
        );
    }

    private exitPolygonDrawMode(): void {
        this.endDrawSession('polygon');
    }

    private enterPolylineDrawMode(target: MapDrawType = MapDrawType.MEASURE): void {
        this.beginVertexSession(
            'polyline',
            target,
            'Click to add points along the route. Double-click or press Enter to finish, Esc to cancel.'
        );
    }

    private exitPolylineDrawMode(): void {
        this.endDrawSession('polyline');
    }

    // ------------------------------------------------------- session lifecycle

    /**
     * Arm a drag tool. Map panning is disabled so the drag draws instead of
     * moving the map.
     */
    private beginDragSession(kind: DragDrawKind, target: MapDrawType): void {
        if (!this.openSession(kind, target, { disablePan: true })) {
            return;
        }

        this.drawSession.listeners = [
            this.mapElement.addListener('mousedown', (e: any) => this.onDragStart(e)),
            this.mapElement.addListener('mousemove', (e: any) => this.onDragMove(e)),
            this.mapElement.addListener('mouseup', (e: any) => this.onDragEnd(e))
        ];
    }

    /**
     * Arm a vertex tool. Panning stays enabled here - a click does not conflict
     * with a pan, and a large shape often needs the map moved mid-draw.
     */
    private beginVertexSession(kind: VertexDrawKind, target: MapDrawType, hint: string): void {
        if (!this.openSession(kind, target, { disablePan: false })) {
            return;
        }

        this.drawSession.listeners = [
            this.mapElement.addListener('click', (e: any) => this.onVertexClick(e)),
            this.mapElement.addListener('mousemove', (e: any) => this.onVertexMove(e)),
            this.mapElement.addListener('dblclick', () => this.onVertexFinish()),
            this.mapElement.addListener('rightclick', () => this.onVertexUndo())
        ];

        // Escape abandons, Enter finishes. Registered on the capture phase so an
        // overlay that swallows keydown cannot trap the user in an unfinishable draw.
        const keyHandler = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                event.stopPropagation();
                this.disarmActiveTool();
            } else if (event.key === 'Enter') {
                event.stopPropagation();
                this.onVertexFinish();
            }
        };
        this.drawSession.keyHandler = keyHandler;
        document.addEventListener('keydown', keyHandler, true);

        this.notifService.success(hint);
    }

    /**
     * Open a session and put the map into capture mode. Returns false when the
     * tool cannot arm, so callers can bail without touching session state.
     */
    private openSession(
        kind: DrawKind,
        target: MapDrawType,
        options: { disablePan: boolean }
    ): boolean {
        if (this.drawSession || !this.mapElement) {
            return false;
        }

        this.drawSession = {
            kind,
            target,
            color: target === MapDrawType.MEASURE ? shapeMeasurementColor : shapeSelectColor,
            listeners: [],
            keyHandler: null,
            anchor: null,
            vertices: [],
            vertexMarkers: [],
            preview: null
        };

        this.mapElement.setOptions({
            draggableCursor: 'crosshair',
            disableDoubleClickZoom: true,
            ...(options.disablePan ? { draggable: false } : {})
        });

        return true;
    }

    /**
     * Disarm the named tool and restore the map. Ignores the call when a
     * different tool owns the session, so a stale unsubscribe cannot cancel the
     * tool the user just picked.
     */
    private endDrawSession(kind: DrawKind): void {
        const session = this.drawSession;
        if (!session || session.kind !== kind) {
            return;
        }

        session.listeners.forEach((listener) => google.maps.event.removeListener(listener));

        if (session.keyHandler) {
            // Must match the capture flag used at registration, or the listener stays.
            document.removeEventListener('keydown', session.keyHandler, true);
        }

        this.discardPreview(session);
        this.drawSession = null;

        if (this.mapElement) {
            this.mapElement.setOptions({
                draggableCursor: null,
                draggable: true,
                disableDoubleClickZoom: false
            });
        }
    }

    /** Ask the state service to disarm whatever is active, so the UI stays in step. */
    private disarmActiveTool(): void {
        switch (this.drawSession?.kind) {
            case 'rectangle':
                this.circleSelectionStateService.exitRectangleDrawMode();
                break;
            case 'circle':
                this.circleSelectionStateService.exitCircleDragDrawMode();
                break;
            case 'polygon':
                this.circleSelectionStateService.exitPolygonDrawMode();
                break;
            case 'polyline':
                this.circleSelectionStateService.exitPolylineDrawMode();
                break;
        }
    }

    /**
     * Remove the throwaway preview and any vertex dots. Safe at any point, so an
     * abandoned draw never leaks an overlay.
     */
    private discardPreview(session: DrawSession): void {
        session.preview?.setMap(null);
        session.preview = null;

        session.vertexMarkers.forEach((marker) => marker.setMap(null));
        session.vertexMarkers = [];
        session.vertices = [];
        session.anchor = null;
    }

    // -------------------------------------------------------------- drag family

    private onDragStart(event: any): void {
        const session = this.drawSession;
        if (!session || !event.latLng) {
            return;
        }

        session.anchor = event.latLng;

        const style = {
            map: this.mapElement,
            strokeColor: session.color,
            strokeOpacity: 0.9,
            strokeWeight: 2,
            fillColor: session.color,
            fillOpacity: 0.15,
            clickable: false,
            draggable: false,
            editable: false,
            zIndex: 1
        };

        session.preview =
            session.kind === 'rectangle'
                ? new google.maps.Rectangle({
                      ...style,
                      bounds: this.boundsFromCorners(event.latLng, event.latLng)
                  })
                : new google.maps.Circle({ ...style, center: event.latLng, radius: 0 });
    }

    private onDragMove(event: any): void {
        const session = this.drawSession;
        if (!session?.anchor || !session.preview || !event.latLng) {
            return;
        }

        if (session.kind === 'rectangle') {
            (session.preview as google.maps.Rectangle).setBounds(
                this.boundsFromCorners(session.anchor, event.latLng)
            );
        } else {
            (session.preview as google.maps.Circle).setRadius(
                google.maps.geometry.spherical.computeDistanceBetween(session.anchor, event.latLng)
            );
        }
    }

    /**
     * Finalise on release. The release point is preferred over the preview, which
     * only tracks the last mousemove and so lags behind a fast drag. A drag too
     * small to be deliberate is discarded, so a stray click cannot create a
     * zero-area shape.
     */
    private onDragEnd(event: any): void {
        const session = this.drawSession;
        if (!session?.anchor || !session.preview) {
            return;
        }

        const anchor = session.anchor;
        const release: google.maps.LatLng | null = event?.latLng ?? null;
        const isRectangle = session.kind === 'rectangle';

        const bounds = isRectangle
            ? release
                ? this.boundsFromCorners(anchor, release)
                : (session.preview as google.maps.Rectangle).getBounds()
            : null;

        const radius = isRectangle
            ? 0
            : release
            ? google.maps.geometry.spherical.computeDistanceBetween(anchor, release)
            : (session.preview as google.maps.Circle).getRadius();

        const target = session.target;
        this.discardPreview(session);

        if (isRectangle) {
            const diagonal = bounds
                ? google.maps.geometry.spherical.computeDistanceBetween(
                      bounds.getNorthEast(),
                      bounds.getSouthWest()
                  )
                : 0;
            if (bounds && diagonal >= this.RECTANGLE_DRAG_MIN_DIAGONAL_METERS) {
                this.commitRectangle(bounds, target);
            }
        } else if (radius >= this.CIRCLE_DRAG_MIN_RADIUS_METERS) {
            this.commitCircle(anchor, radius, target);
        }

        // One shape per activation, matching how the Select tools behave.
        this.disarmActiveTool();
    }

    /**
     * Bounds from two opposite corners. LatLngBounds.extend normalises them, so
     * dragging in any of the four directions works identically.
     */
    private boundsFromCorners(
        cornerA: google.maps.LatLng,
        cornerB: google.maps.LatLng
    ): google.maps.LatLngBounds {
        const bounds = new google.maps.LatLngBounds();
        bounds.extend(cornerA);
        bounds.extend(cornerB);
        return bounds;
    }

    // ------------------------------------------------------------ vertex family

    /**
     * click: commit one point - or, for a polygon whose ring is wide enough,
     * close it if the click landed back on the first vertex.
     *
     * Closing on the first vertex is the primary finish gesture because it rides
     * on the same click event that adds points. dblclick and Enter remain as
     * alternatives, but neither is required to end a draw.
     */
    private onVertexClick(event: any): void {
        const session = this.drawSession;
        if (!session || !event.latLng) {
            return;
        }

        if (session.kind === 'polygon' && this.isClosingClick(session, event.latLng)) {
            this.onVertexFinish();
            return;
        }

        session.vertices.push(event.latLng);

        // A polygon's first vertex doubles as the "click here to finish" target, so
        // it is drawn larger and has to stay findable once the ring is wide.
        const isClosingTarget = session.kind === 'polygon' && session.vertices.length === 1;

        session.vertexMarkers.push(
            new google.maps.Marker({
                position: event.latLng,
                map: this.mapElement,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: isClosingTarget ? 8 : 5,
                    fillColor: isClosingTarget ? '#ffffff' : session.color,
                    fillOpacity: 1,
                    strokeColor: isClosingTarget ? session.color : '#ffffff',
                    strokeWeight: isClosingTarget ? 3 : 2
                },
                title: isClosingTarget ? 'Click here to finish the polygon' : undefined,
                clickable: false,
                draggable: false,
                zIndex: 1500,
                optimized: false
            })
        );

        this.renderVertexPreview(session, event.latLng);
    }

    /** mousemove: rubber-band the provisional edge to the cursor. */
    private onVertexMove(event: any): void {
        const session = this.drawSession;
        if (!session || session.vertices.length === 0 || !event.latLng) {
            return;
        }
        this.renderVertexPreview(session, event.latLng);
    }

    /**
     * rightclick: undo the last point. Undoing past the first leaves the tool
     * armed with an empty preview rather than exiting, so a misclick is cheap.
     */
    private onVertexUndo(): void {
        const session = this.drawSession;
        if (!session || session.vertices.length === 0) {
            return;
        }

        session.vertices.pop();
        session.vertexMarkers.pop()?.setMap(null);

        if (session.vertices.length === 0) {
            session.preview?.setMap(null);
            session.preview = null;
            return;
        }

        this.renderVertexPreview(session);
    }

    /**
     * dblclick / Enter / closing click: commit the shape.
     *
     * A double click may arrive as click+dblclick or click+click+dblclick
     * depending on the browser, so a trailing point identical to the one before
     * it is dropped. Below the minimum there is nothing to commit, and the draw
     * is abandoned rather than producing a degenerate shape.
     */
    private onVertexFinish(): void {
        const session = this.drawSession;
        if (!session || (session.kind !== 'polygon' && session.kind !== 'polyline')) {
            return;
        }

        const vertices = session.vertices.slice();
        while (
            vertices.length >= 2 &&
            vertices[vertices.length - 1].equals(vertices[vertices.length - 2])
        ) {
            vertices.pop();
        }

        const kind = session.kind;
        const target = session.target;

        if (vertices.length >= this.MIN_VERTICES[kind]) {
            if (kind === 'polygon') {
                this.commitPolygon(vertices, target);
            } else {
                this.commitPolyline(vertices);
            }
        }

        this.disarmActiveTool();
    }

    /**
     * Redraw the preview as the committed points plus, while the pointer is over
     * the map, the cursor as a provisional final point.
     *
     * Both kinds preview as an open polyline, so a polygon is drawn edge by edge
     * with no closing edge or fill until the ring is closed and committed.
     */
    private renderVertexPreview(session: DrawSession, cursor?: google.maps.LatLng): void {
        const path = cursor ? session.vertices.concat(cursor) : session.vertices.slice();
        if (path.length === 0) {
            return;
        }

        if (!session.preview) {
            session.preview = new google.maps.Polyline({
                map: this.mapElement,
                path,
                strokeColor: session.color,
                strokeOpacity: 0.9,
                strokeWeight: session.kind === 'polygon' ? 2 : drawingOptions.polyline.strokeWeight,
                clickable: false,
                draggable: false,
                editable: false,
                zIndex: 1
            });
            return;
        }

        (session.preview as google.maps.Polyline).setPath(path);
    }

    /**
     * True when a click landed back on the first vertex. The tolerance is in
     * screen pixels, converted through the ground resolution at the current zoom,
     * so it feels the same however far in or out the map is.
     */
    private isClosingClick(session: DrawSession, latLng: google.maps.LatLng): boolean {
        if (session.vertices.length < this.MIN_VERTICES.polygon) {
            return false;
        }

        const first = session.vertices[0];
        const zoom = this.mapElement?.getZoom() ?? 3;
        const metersPerPixel =
            (156543.03392 * Math.cos((first.lat() * Math.PI) / 180)) / Math.pow(2, zoom);

        return (
            google.maps.geometry.spherical.computeDistanceBetween(first, latLng) <=
            this.VERTEX_CLOSE_PIXEL_RADIUS * metersPerPixel
        );
    }

    // ------------------------------------------------------------------ commits
    //
    // Each hands the captured geometry to the completion handler DrawingManager
    // used to call. isMeasurementDrawing decides which array the shape lands in
    // and whether it updates the datapoint filter. The overlays are deliberately
    // not placed on the map: the committed shape is rendered by the agm-* binding
    // over the state arrays, so adding it here would draw it twice.

    private commitRectangle(bounds: google.maps.LatLngBounds, target: MapDrawType): void {
        // A rectangle reaches the backend as four numbers rather than a coordinate
        // list, so a single bad edge yields a shape the filter cannot honour and
        // every datapoint comes back. Refuse to commit one that is not well formed.
        const ne = bounds?.getNorthEast();
        const sw = bounds?.getSouthWest();
        const edges = {
            north: ne?.lat(),
            south: sw?.lat(),
            east: ne?.lng(),
            west: sw?.lng()
        };

        if (!this.hasFiniteBounds(edges) || edges.north <= edges.south) {
            this.notifService.error('Could not read the rectangle bounds - please draw it again');
            console.warn('[draw] rectangle rejected, unusable bounds', edges);
            return;
        }

        this.isMeasurementDrawing = target === MapDrawType.MEASURE;
        this.onRectangleComplete(new google.maps.Rectangle({ bounds }), true);
        this.logCommit('rectangle', target);
    }

    private commitCircle(center: google.maps.LatLng, radius: number, target: MapDrawType): void {
        this.isMeasurementDrawing = target === MapDrawType.MEASURE;
        this.onCircleComplete(new google.maps.Circle({ center, radius }), true);
        this.logCommit('circle', target);
    }

    private commitPolygon(vertices: google.maps.LatLng[], target: MapDrawType): void {
        this.isMeasurementDrawing = target === MapDrawType.MEASURE;
        this.onPolygonComplete(new google.maps.Polygon({ paths: vertices }), true);
        this.logCommit('polygon', target);
    }

    /** Polylines are measure-only; there is no polyline filter shape. */
    private commitPolyline(vertices: google.maps.LatLng[]): void {
        this.isMeasurementDrawing = true;
        this.onPolylineComplete(new google.maps.Polyline({ path: vertices }));
        this.logCommit('polyline', MapDrawType.MEASURE);
    }

    private logCommit(kind: DrawKind, target: MapDrawType): void {
        if (!MapComponent.DRAW_DEBUG) {
            return;
        }
        console.log(
            `[draw] COMMITTED kind=${kind} target=${target}` +
            ` isMeasurementDrawing=${this.isMeasurementDrawing}` +
            ` | select: poly=${this.polygons.select.length}` +
            ` rect=${this.rectangles.select.length}` +
            ` circ=${this.circles.select.length}` +
            ` | measure: poly=${this.polygons.measure.length}` +
            ` rect=${this.rectangles.measure.length}` +
            ` circ=${this.circles.measure.length}` +
            ` line=${this.polylines.measure.length}`
        );
    }

    /**
     * Task 3: Handle map click for circle placement
     * Creates circle with configured radius at clicked location
     */
    private onMapClickForCirclePlacement(event: any): void {
        // Stop event propagation to prevent interference with existing map click handlers
        if (event.stop) {
            event.stop();
        }
        
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        
        const config = this.circleSelectionStateService.getConfigValue();
        if (!config) {
            this.circleSelectionStateService.exitPlacementMode();
            return;
        }
        
        // Create the circle
        const circle = new google.maps.Circle({
            center: { lat, lng },
            radius: config.radiusInMeters,
            map: this.mapElement,
            strokeColor: shapeSelectColor,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: shapeSelectColor,
            fillOpacity: 0.2, // Semi-transparent so markers underneath are visible
            editable: false,
            draggable: true, // Task 4: Enabled for drag functionality
            clickable: false // Set to false so markers underneath can be clicked
        });
        
        // Create center marker dot
        const marker = new google.maps.Marker({
            position: { lat, lng },
            map: this.mapElement,
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 7, // Increased size to ensure visibility when circle is very small
                fillColor: shapeSelectColor,
                fillOpacity: 1,
                strokeColor: '#ffffff',
                strokeWeight: 2
            },
            draggable: true, // Task 4: Enabled for drag functionality
            clickable: true,
            zIndex: 1500, // Higher than info icon (1000) to ensure center marker is always visible on top
            optimized: false, // Disable marker optimization to prevent disappearing at high zoom
            visible: true // Explicitly set visible to ensure it's always rendered
        });
        
        // Store references in state service
        this.circleSelectionStateService.setActiveCircle(circle);
        this.circleSelectionStateService.setCenterMarker(marker);
        
        // Store references in state service
        this.circleSelectionStateService.setActiveCircle(circle);
        this.circleSelectionStateService.setCenterMarker(marker);
        
        // IMPORTANT: Integrate with existing filtering system
        // Create circle data object for backend filtering
        const circleDrawing: CircleDrawing = {
            radius: config.radiusInMeters,
            latitude: lat,
            longitude: lng,
            unit: config.radiusUnit // Store user's selected unit for saving to filter
        };
        
        // Store this custom circle in our tracking array with user's selected unit
        this.customCircles.push({
            circle: circle,
            marker: marker,
            data: circleDrawing,
            selectedUnit: config.radiusUnit // Store user's selected unit for formatting
        });
        
        // Task 4: Setup drag event listeners to sync circle and marker movement
        // Pass the index so we can update the correct circle in the array
        const circleIndex = this.customCircles.length - 1;
        this.setupCircleDragListeners(circle, marker, circleIndex);
        
        // Update filter service with ALL custom circles
        this.updateFilterWithAllCircles();
        
        // Track analytics
        this.analytics.trackEvent('select_circle_filter_applied');
        
        // Task 6: Add helper tooltip and radius label
        this.addRadiusLabel(circle, circleIndex);
        this.addHoverEffects(circle);
        
        // Add click listener to show Area InfoWindow
        this.addAreaInfoWindow(circle, circleIndex);
        
        // Create info icon marker for this custom circle
        this.createInfoIconForCustomCircle(circleIndex);
        
        // Exit placement mode
        this.circleSelectionStateService.exitPlacementMode();
        
        // Pan map to circle center (optional, for better UX)
        this.mapElement.panTo({ lat, lng });
        
    }

    private setupCircleDragListeners(circle: google.maps.Circle, marker: google.maps.Marker, circleIndex: number): void {
        
        // When circle is dragged, move the marker and info icon to match
        circle.addListener('drag', () => {
            const center = circle.getCenter();
            if (center) {
                marker.setPosition(center);
                
                // Update info icon position
                const customCircle = this.customCircles[circleIndex];
                if (customCircle?.infoIconMarker) {
                    const radius = circle.getRadius();
                    const radiusInDegrees = radius / 111320;
                    const fixedOffset = 0.0002; // ~22 meters, matching polygon logic
                    const iconPosition = {
                        lat: center.lat() + radiusInDegrees + fixedOffset,
                        lng: center.lng() + radiusInDegrees + fixedOffset
                    };
                    customCircle.infoIconMarker.setPosition(iconPosition);
                }
            }
        });
        
        // When circle drag ends, update backend filtering
        circle.addListener('dragend', () => {
            const center = circle.getCenter();
            const radius = circle.getRadius();
            if (center) {
                
                // Update the circle data in our tracking array
                if (this.customCircles[circleIndex]) {
                    this.customCircles[circleIndex].data.latitude = center.lat();
                    this.customCircles[circleIndex].data.longitude = center.lng();
                    this.customCircles[circleIndex].data.radius = radius;
                }
                
                // Update filter service with ALL custom circles
                this.updateFilterWithAllCircles();
            }
        });
        
        // When marker is dragged, move the circle and info icon to match
        marker.addListener('drag', () => {
            const position = marker.getPosition();
            if (position) {
                circle.setCenter(position);
                
                // Update info icon position
                const customCircle = this.customCircles[circleIndex];
                if (customCircle?.infoIconMarker) {
                    const radius = circle.getRadius();
                    const radiusInDegrees = radius / 111320;
                    const fixedOffset = 0.0002; // ~22 meters, matching polygon logic
                    const iconPosition = {
                        lat: position.lat() + radiusInDegrees + fixedOffset,
                        lng: position.lng() + radiusInDegrees + fixedOffset
                    };
                    customCircle.infoIconMarker.setPosition(iconPosition);
                }
            }
        });
        
        // When marker drag ends, update backend filtering
        marker.addListener('dragend', () => {
            const position = marker.getPosition();
            const radius = circle.getRadius();
            if (position) {
                
                // Update the circle data in our tracking array
                if (this.customCircles[circleIndex]) {
                    this.customCircles[circleIndex].data.latitude = position.lat();
                    this.customCircles[circleIndex].data.longitude = position.lng();
                    this.customCircles[circleIndex].data.radius = radius;
                }
                
                // Update filter service with ALL custom circles
                this.updateFilterWithAllCircles();
            }
        });
        
        // Task 5: Setup right-click resize functionality
        this.setupCircleResizeListeners(circle, marker, circleIndex);
    }
    
    /**
     * Task 5: Setup right-click resize functionality for circle
     * Creates four resize handles on the circle's edge (top, bottom, left, right) that can be dragged to resize
     */
    private setupCircleResizeListeners(circle: google.maps.Circle, marker: google.maps.Marker, circleIndex: number): void {
        
        let isResizing = false;
        
        // Create resize handles immediately when circle loads
        const center = circle.getCenter();
        const radius = circle.getRadius();
        
        if (center) {
            // Calculate radius in degrees for positioning
            const radiusInDegrees = radius / this.METERS_TO_DEGREES_CONVERSION;
            const latCosCorrection = Math.cos(center.lat() * Math.PI / 180);
            
            // Define positions for 4 handles: right, top, left, bottom
            const handlePositions = [
                {
                    // Right
                    lat: center.lat(),
                    lng: center.lng() + radiusInDegrees / latCosCorrection,
                    cursor: 'ew-resize'
                },
                {
                    // Top
                    lat: center.lat() + radiusInDegrees,
                    lng: center.lng(),
                    cursor: 'ns-resize'
                },
                {
                    // Left
                    lat: center.lat(),
                    lng: center.lng() - radiusInDegrees / latCosCorrection,
                    cursor: 'ew-resize'
                },
                {
                    // Bottom
                    lat: center.lat() - radiusInDegrees,
                    lng: center.lng(),
                    cursor: 'ns-resize'
                }
            ];
            
            // Create info window for live tooltip showing formatted radius
            const tooltipInfoWindow = new google.maps.InfoWindow({
                disableAutoPan: true,
                disableCloseButton: true,
                pixelOffset: new google.maps.Size(0, -10)
            });
            
            // Initialize resize handles array for this circle
            const resizeHandles: google.maps.Marker[] = [];
            
            // Create all four resize handles
            handlePositions.forEach((position) => {
                const resizeHandle = new google.maps.Marker({
                    position: { lat: position.lat, lng: position.lng },
                    map: this.mapElement,
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 6,
                        fillColor: '#ffffff',
                        fillOpacity: 1,
                        strokeColor: '#0073c4',
                        strokeWeight: 2
                    },
                    draggable: true,
                    clickable: true,
                    cursor: position.cursor,
                    title: 'Drag to resize circle'
                });
                
                resizeHandles.push(resizeHandle);
                
                // Show tooltip when resize starts
                resizeHandle.addListener('dragstart', () => {
                    // Hide permanent radius label to avoid duplicate InfoWindows
                    this.hidePermanentLabel(circleIndex);
                    
                    // Close Area InfoWindow if open
                    const areaInfoWindow = (this.customCircles[circleIndex] as any)?.areaInfoWindow;
                    if (areaInfoWindow) {
                        areaInfoWindow.close();
                    }
                    
                    const currentRadius = circle.getRadius();
                    const userUnit = this.customCircles[circleIndex]?.selectedUnit || 'miles';
                    const formattedRadius = CircleTooltipHelper.formatRadiusForTooltip(currentRadius, userUnit, false);
                    tooltipInfoWindow.setContent(CircleTooltipHelper.createProfessionalTooltipContent(formattedRadius));
                    tooltipInfoWindow.open(this.mapElement, resizeHandle);
                });
                
                // When resize handle is dragged, update circle radius and all other handles
                resizeHandle.addListener('drag', () => {
                    isResizing = true;
                    const handlePosition = resizeHandle.getPosition();
                    const circleCenter = circle.getCenter();
                    
                    if (handlePosition && circleCenter) {
                        // Calculate new radius based on distance from center to handle
                        let newRadius = google.maps.geometry.spherical.computeDistanceBetween(
                            circleCenter,
                            handlePosition
                        );
                        
                        // Update circle radius
                        circle.setRadius(newRadius);
                        
                        // Update all handle positions to match new radius
                        const newRadiusInDegrees = newRadius / this.METERS_TO_DEGREES_CONVERSION;
                        const newLatCosCorrection = Math.cos(circleCenter.lat() * Math.PI / 180);
                        
                        const newPositions = [
                            { lat: circleCenter.lat(), lng: circleCenter.lng() + newRadiusInDegrees / newLatCosCorrection }, // Right
                            { lat: circleCenter.lat() + newRadiusInDegrees, lng: circleCenter.lng() }, // Top
                            { lat: circleCenter.lat(), lng: circleCenter.lng() - newRadiusInDegrees / newLatCosCorrection }, // Left
                            { lat: circleCenter.lat() - newRadiusInDegrees, lng: circleCenter.lng() }  // Bottom
                        ];
                        
                        resizeHandles.forEach((handle, index) => {
                            handle.setPosition(newPositions[index]);
                        });
                        
                        // Update info icon position to match new radius
                        const customCircle = this.customCircles[circleIndex];
                        if (customCircle && customCircle.infoIconMarker) {
                            const minOffsetDegrees = 0.0002;
                            const offsetDegrees = Math.max(newRadiusInDegrees, minOffsetDegrees);
                            const iconPosition = {
                                lat: circleCenter.lat() + offsetDegrees,
                                lng: circleCenter.lng() + offsetDegrees
                            };
                            customCircle.infoIconMarker.setPosition(iconPosition);
                        }
                        
                        // Update tooltip with formatted radius
                        const userUnit = this.customCircles[circleIndex]?.selectedUnit || 'miles';
                        const formattedRadius = CircleTooltipHelper.formatRadiusForTooltip(newRadius, userUnit, false);
                        tooltipInfoWindow.setContent(CircleTooltipHelper.createProfessionalTooltipContent(formattedRadius));
                    }
                });
                
                // When resize handle drag ends, update backend filtering
                resizeHandle.addListener('dragend', () => {
                    const handlePosition = resizeHandle.getPosition();
                    const circleCenter = circle.getCenter();
                    
                    if (handlePosition && circleCenter) {
                        const newRadius = google.maps.geometry.spherical.computeDistanceBetween(
                            circleCenter,
                            handlePosition
                        );
                        
                        // Update the circle data in our tracking array
                        if (this.customCircles[circleIndex]) {
                            this.customCircles[circleIndex].data.radius = newRadius;
                        }
                        
                        // Update filter service with ALL custom circles
                        this.updateFilterWithAllCircles();
                        
                        // Close resize tooltip
                        tooltipInfoWindow.close();
                        
                        // Show permanent radius label again after resize
                        this.showPermanentLabel(circleIndex);
                        
                        isResizing = false;
                    }
                });
            });
            
            // Store resize handles and tooltip in customCircles for cleanup
            if (this.customCircles[circleIndex]) {
                this.customCircles[circleIndex].resizeHandles = resizeHandles;
                this.customCircles[circleIndex].resizeTooltip = tooltipInfoWindow;
            }
            
            // Update handle positions when circle center changes (when circle is moved)
            circle.addListener('center_changed', () => {
                if (!isResizing) {
                    const newCenter = circle.getCenter();
                    const currentRadius = circle.getRadius();
                    if (newCenter) {
                        const newRadiusInDegrees = currentRadius / this.METERS_TO_DEGREES_CONVERSION;
                        const newLatCosCorrection = Math.cos(newCenter.lat() * Math.PI / 180);
                        
                        const newPositions = [
                            { lat: newCenter.lat(), lng: newCenter.lng() + newRadiusInDegrees / newLatCosCorrection }, // Right
                            { lat: newCenter.lat() + newRadiusInDegrees, lng: newCenter.lng() }, // Top
                            { lat: newCenter.lat(), lng: newCenter.lng() - newRadiusInDegrees / newLatCosCorrection }, // Left
                            { lat: newCenter.lat() - newRadiusInDegrees, lng: newCenter.lng() }  // Bottom
                        ];
                        
                        resizeHandles.forEach((handle, index) => {
                            handle.setPosition(newPositions[index]);
                        });
                    }
                }
            });
        }
    }
    
    /**
     * Helper method to update filter service with ALL custom circles
     * This ensures all circles (both template and custom) are included in filtering
     */
    private updateFilterWithAllCircles(): void {
        // Extract circle data from all custom circles
        const customCircleData = this.customCircles.map(item => item.data);
        
        // Update filter service with ALL circles (template + custom)
        this.datapointsFilterService.updateShapes({
            rectangles: this.rectangles.select,
            circles: [...this.circles.select, ...customCircleData], // Include ALL custom circles
            polygons: this.polygons.select,
        });
        
    }
    
    /**
     * Task 6: Add permanent radius label on circle
     * Updates when circle is resized or moved
     */
    private addRadiusLabel(circle: google.maps.Circle, circleIndex: number): void {
        
        const center = circle.getCenter();
        const radius = circle.getRadius();
        const userUnit = this.customCircles[circleIndex]?.selectedUnit || 'miles';
        
        if (center) {
            // Create label InfoWindow with user's selected unit (show only selected unit, no secondary)
            const radiusLabel = new google.maps.InfoWindow({
                content: CircleTooltipHelper.createRadiusLabelContent(radius, userUnit, false), // false = show only selected unit
                disableAutoPan: true,
                disableCloseButton: true, // Remove X button for cleaner look
                pixelOffset: new google.maps.Size(0, 0)
            });
            
            // Position at circle center
            radiusLabel.setPosition(center);
            radiusLabel.open(this.mapElement);
            
            // Store reference in customCircles array for updates
            if (this.customCircles[circleIndex]) {
                this.customCircles[circleIndex].radiusLabel = radiusLabel;
            }
            
            // Update label whenever the circle moves. center_changed rather than drag:
            // the center handle and info icon move the circle via setCenter, which
            // fires center_changed but never drag.
            circle.addListener('center_changed', () => {
                const newCenter = circle.getCenter();
                if (newCenter && radiusLabel) {
                    radiusLabel.setPosition(newCenter);
                }
            });
            
            // Update label when circle is resized
            circle.addListener('radius_changed', () => {
                const newRadius = circle.getRadius();
                if (radiusLabel) {
                    radiusLabel.setContent(CircleTooltipHelper.createRadiusLabelContent(newRadius, userUnit, false)); // false = show only selected unit
                }
            });
        }
    }
    
    /**
     * Task 6: Add hover effects to circle
     * Highlights circle on mouseover
     */
    private addHoverEffects(circle: google.maps.Circle): void {
        
        const originalStrokeWeight = circle.get('strokeWeight') || 2;
        const originalStrokeOpacity = circle.get('strokeOpacity') || 0.8;
        const originalFillOpacity = circle.get('fillOpacity') || 0.15;
        
        // Mouseover: Highlight circle
        circle.addListener('mouseover', () => {
            circle.setOptions({
                strokeWeight: originalStrokeWeight + 1,
                strokeOpacity: 1,
                fillOpacity: originalFillOpacity + 0.1
            });
        });
        
        // Mouseout: Restore original style
        circle.addListener('mouseout', () => {
            circle.setOptions({
                strokeWeight: originalStrokeWeight,
                strokeOpacity: originalStrokeOpacity,
                fillOpacity: originalFillOpacity
            });
        });
    }
    
    /**
     * Helper method to hide permanent radius label
     * Eliminates code duplication across multiple methods
     */
    private hidePermanentLabel(circleIndex: number): void {
        const permanentLabel = this.customCircles[circleIndex]?.radiusLabel;
        if (permanentLabel) {
            permanentLabel.close();
        }
    }
    
    /**
     * Helper method to show permanent radius label
     * Eliminates code duplication across multiple methods
     */
    private showPermanentLabel(circleIndex: number): void {
        const permanentLabel = this.customCircles[circleIndex]?.radiusLabel;
        if (permanentLabel) {
            permanentLabel.open(this.mapElement);
        }
    }
    
    /**
     * Remove resize handles from a specific circle
     * Edge Cases 1, 2, 4: Called when circle/marker is dragged or circle is deleted
     */
    private removeResizeHandles(circleIndex: number): void {
        const circleItem = this.customCircles[circleIndex];
        if (!circleItem) return;
        
        // Remove all resize handle markers from map
        if (circleItem.resizeHandles) {
            circleItem.resizeHandles.forEach(handle => handle.setMap(null));
            circleItem.resizeHandles = undefined;
        }
        
        // Close resize tooltip
        if (circleItem.resizeTooltip) {
            circleItem.resizeTooltip.close();
            circleItem.resizeTooltip = undefined;
        }
    }
    
    /**
     * Remove resize handles from ALL circles
     * Edge Cases 3, 6: Only one circle should show resize handles at a time
     */
    private removeAllResizeHandles(): void {
        this.customCircles.forEach((_, index) => {
            this.removeResizeHandles(index);
        });
    }
    
    /**
     * Add Area InfoWindow to custom circle
     * Shows area in different units (km², mi², m², ft²) and radius information
     * Displayed when user clicks on the circle
     */
    private addAreaInfoWindow(circle: google.maps.Circle, circleIndex: number): void {
        // Helper function to generate InfoWindow content with current radius
        const generateContent = () => {
            const radius = circle.getRadius();
            const area = this.computeCircleArea(radius);
            
            // Format area in different units
            const areaKm2 = this.decimalPipe.transform(this.squareMToSquareKm(area), '1.0-2');
            const areaMi2 = this.decimalPipe.transform(this.squareMToSquareMi(area), '1.0-2');
            const areaM2 = this.decimalPipe.transform(area, '1.0-2');
            const areaFt2 = this.decimalPipe.transform(this.squareMToSquareFeet(area), '1.0-2');
            
            // Format radius in different units
            const radiusKm = this.decimalPipe.transform(this.mToKm(radius), '1.0-2');
            const radiusMi = this.decimalPipe.transform(this.mToMi(radius), '1.0-2');
            const radiusM = this.decimalPipe.transform(this.mToMeter(radius), '1.0-2');
            const radiusFt = this.decimalPipe.transform(this.mToFeet(radius), '1.0-2');
            
            return `
                <div class="info-box-content">
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                        <div class="tooltip-subtitle" style="color: #1976d2; font-weight: 600;">Area</div>
                        <div class="tooltip-subtitle copy-text" style="cursor: pointer; color: #1976d2; font-weight: 500;">Copy All</div>
                    </div>
                    <hr class="menu-line-separator" />
                    <div class="tooltip-value font-12 measurment-container">
                        <span class="copy-text" style="cursor: pointer; color: #1976d2;">${areaKm2}&nbsp;km<sup>2</sup></span>
                    </div><hr class="menu-line-separator" />
                    <div class="tooltip-value font-12 measurment-container">
                        <span class="copy-text" style="cursor: pointer; color: #1976d2;">${areaMi2}&nbsp;mi<sup>2</sup></span>
                    </div><hr class="menu-line-separator" />
                    <div class="tooltip-value font-12 measurment-container">
                        <span class="copy-text" style="cursor: pointer; color: #1976d2;">${areaM2}&nbsp;m<sup>2</sup></span>
                    </div><hr class="menu-line-separator" />
                    <div class="tooltip-value font-12 measurment-container">
                        <span class="copy-text" style="cursor: pointer; color: #1976d2;">${areaFt2}&nbsp;ft<sup>2</sup></span>
                    </div><hr class="menu-line-separator" />
                    
                    <div class="tooltip-subtitle" style="color: #1976d2; font-weight: 600; margin-top: 8px;">Radius</div><hr class="menu-line-separator" />
                    <span class="agm-window-radius-font">
                        <div class="tooltip-value" style="color: #333;">${radiusKm}&nbsp;km</div><hr class="menu-line-separator" />
                        <div class="tooltip-value" style="color: #333;">${radiusMi}&nbsp;mi</div><hr class="menu-line-separator" />
                        <div class="tooltip-value" style="color: #333;">${radiusM}&nbsp;m</div><hr class="menu-line-separator" />
                        <div class="tooltip-value" style="color: #333;">${radiusFt}&nbsp;ft</div><hr class="menu-line-separator" />
                    </span>
                </div>
            `;
        };
        
        const center = circle.getCenter();
        if (!center) return;
        
        // Create InfoWindow with initial content
        const areaInfoWindow = new google.maps.InfoWindow({
            content: generateContent(),
            position: center
        });
        
        // Store reference for cleanup
        if (this.customCircles[circleIndex]) {
            (this.customCircles[circleIndex] as any).areaInfoWindow = areaInfoWindow;
        }
        
        // Update InfoWindow content when circle is resized
        circle.addListener('radius_changed', () => {
            const newCenter = circle.getCenter();
            if (newCenter) {
                areaInfoWindow.setContent(generateContent());
                areaInfoWindow.setPosition(newCenter);
            }
        });
        
        // Update InfoWindow position when circle is dragged
        circle.addListener('drag', () => {
            const newCenter = circle.getCenter();
            if (newCenter) {
                areaInfoWindow.setPosition(newCenter);
            }
        });
        
        // NOTE: Circle click listener removed - info window now opens via "i" icon click
        // The info icon marker will handle opening the area info window
        
        // When InfoWindow is closed, show radius label again
        google.maps.event.addListener(areaInfoWindow, 'closeclick', () => {
            this.showPermanentLabel(circleIndex);
        });
        
        // Add click listeners to copy functionality
        google.maps.event.addListenerOnce(areaInfoWindow, 'domready', () => {
            const copyAllBtn = document.querySelector('.info-box-content .copy-text');
            if (copyAllBtn) {
                copyAllBtn.addEventListener('click', () => {
                    // Get current radius from circle
                    const currentRadius = circle.getRadius();
                    this.copyAllMeasureCircle(currentRadius);
                });
            }
            
            // Add individual copy listeners
            const copySpans = document.querySelectorAll('.measurment-container .copy-text');
            copySpans.forEach((span, index) => {
                span.addEventListener('click', () => {
                    // Get current area from circle
                    const currentRadius = circle.getRadius();
                    const currentArea = this.computeCircleArea(currentRadius);
                    if (index === 0) this.onClickMeasurment('squareMToSquareKm', currentArea);
                    else if (index === 1) this.onClickMeasurment('squareMToSquareMi', currentArea);
                    else if (index === 2) this.onClickMeasurment('computeCircleArea', currentArea);
                    else if (index === 3) this.onClickMeasurment('squareMToSquareFeet', currentArea);
                });
            });
        });
    }
    
    /**
     * Task 7: Clear all custom circles and cleanup
     * Complete cleanup of all circle-related objects, state reset, and event listeners
     * @param updateFilter - Whether to update the filter service (default: true). Set to false when component is being destroyed during view switching.
     */
    clearAllCustomCircles(updateFilter: boolean = true): void {
        
        if (!this.customCircles || this.customCircles.length === 0) {
            return;
        }
        
        // Cleanup each circle
        this.customCircles.forEach((circleItem, index) => {
            
            try {
                // Edge Case 4: Remove resize handles if visible
                this.removeResizeHandles(index);
                
                // Remove circle from map
                if (circleItem.circle) {
                    google.maps.event.clearInstanceListeners(circleItem.circle);
                    circleItem.circle.setMap(null);
                }
                
                // Remove center marker from map
                if (circleItem.marker) {
                    google.maps.event.clearInstanceListeners(circleItem.marker);
                    circleItem.marker.setMap(null);
                }
                
                // Remove info icon marker from map
                if (circleItem.infoIconMarker) {
                    google.maps.event.clearInstanceListeners(circleItem.infoIconMarker);
                    circleItem.infoIconMarker.setMap(null);
                    circleItem.infoIconMarker = undefined;
                }
                
                // Close and cleanup radius label if exists
                if (circleItem.radiusLabel) {
                    circleItem.radiusLabel.close();
                    circleItem.radiusLabel = undefined;
                }
                
                // Close and cleanup area InfoWindow if exists
                if ((circleItem as any).areaInfoWindow) {
                    (circleItem as any).areaInfoWindow.close();
                    (circleItem as any).areaInfoWindow = undefined;
                }
            } catch (error) {
                console.error(`[MapComponent] Error cleaning up circle ${index + 1}:`, error);
            }
        });
        
        // Clear the array
        this.customCircles = [];
        
        // Update filter service to remove all custom circles from backend
        // Only update filter if explicitly requested (not during view switching)
        if (updateFilter) {
            this.updateFilterWithAllCircles();
        }
        
        // Reset state service
        this.circleSelectionStateService.exitPlacementMode();
    }
    
    /**
     * Task 7: Clear a specific custom circle by index
     * Cleanup single circle with all its associated objects
     */
    clearCustomCircleByIndex(index: number): void {
        
        if (!this.customCircles || index < 0 || index >= this.customCircles.length) {
            return;
        }
        
        const circleItem = this.customCircles[index];
        
        try {
            // Edge Case 4: Remove resize handles if visible
            this.removeResizeHandles(index);
            
            // Remove circle from map
            if (circleItem.circle) {
                google.maps.event.clearInstanceListeners(circleItem.circle);
                circleItem.circle.setMap(null);
            }
            
            // Remove center marker from map
            if (circleItem.marker) {
                google.maps.event.clearInstanceListeners(circleItem.marker);
                circleItem.marker.setMap(null);
            }
            
            // Remove info icon marker from map
            if (circleItem.infoIconMarker) {
                google.maps.event.clearInstanceListeners(circleItem.infoIconMarker);
                circleItem.infoIconMarker.setMap(null);
                circleItem.infoIconMarker = undefined;
            }
            
            // Close and cleanup radius label if exists
            if (circleItem.radiusLabel) {
                circleItem.radiusLabel.close();
                circleItem.radiusLabel = undefined;
            }
            
            // Close and cleanup area InfoWindow if exists
            if ((circleItem as any).areaInfoWindow) {
                (circleItem as any).areaInfoWindow.close();
                (circleItem as any).areaInfoWindow = undefined;
            }
            
            // Remove from array
            this.customCircles.splice(index, 1);
        } catch (error) {
            console.error(`[MapComponent] Error clearing circle at index ${index}:`, error);
        }
    }

    /**
     * Add custom circle from saved filter data
     * Used when loading circles from saved filters
     * Supports unit conversion for old records (defaults to meters)
     */
    addCustomCircleFromFilter(latitude: number, longitude: number, radiusInMeters: number, unit?: string): void {
        // Default to meters for old records that don't have unit saved
        const circleUnit = unit || 'meters';
        
        // Create the circle with new implementation
        const circle = new google.maps.Circle({
            center: { lat: latitude, lng: longitude },
            radius: radiusInMeters,
            map: this.mapElement,
            strokeColor: shapeSelectColor,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: shapeSelectColor,
            fillOpacity: 0.15,
            editable: false,
            draggable: true,
            clickable: false  // Make non-clickable so markers underneath can be clicked
        });
        
        // Create center marker dot
        const marker = new google.maps.Marker({
            position: { lat: latitude, lng: longitude },
            map: this.mapElement,
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 5,
                fillColor: shapeSelectColor,
                fillOpacity: 1,
                strokeColor: '#ffffff',
                strokeWeight: 2
            },
            draggable: true,
            clickable: true
        });
        
        // Create circle data object for backend filtering
        const circleDrawing: CircleDrawing = {
            radius: radiusInMeters,
            latitude: latitude,
            longitude: longitude,
            unit: circleUnit
        };
        
        // Store this custom circle in our tracking array
        this.customCircles.push({
            circle: circle,
            marker: marker,
            data: circleDrawing,
            selectedUnit: circleUnit
        });
        
        // Setup drag event listeners
        const circleIndex = this.customCircles.length - 1;
        this.setupCircleDragListeners(circle, marker, circleIndex);
        
        // Add features: radius label, hover effects, area info window
        this.addRadiusLabel(circle, circleIndex);
        this.addHoverEffects(circle);
        this.addAreaInfoWindow(circle, circleIndex);
        
        // Create info icon marker (the "i" button) for this circle
        this.createInfoIconForCustomCircle(circleIndex);
        
        // Update filter service with ALL custom circles
        this.updateFilterWithAllCircles();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.destroy$.next();
        this.destroy$.complete();
        this.renderer.removeClass(document.body, 'custom-recaptcha-page');
        this.clearPathListeners();
        
        // Clean up circle placement listener if exists
        if (this.circlePlacementClickListener) {
            google.maps.event.removeListener(this.circlePlacementClickListener);
        }

        // Disarm the in-house draw tools. The polygon and polyline tools in
        // particular hold document-level keydown handlers that would outlive the
        // component.
        this.exitRectangleDrawMode();
        this.exitPolygonDrawMode();
        this.exitPolylineDrawMode();
        this.exitCircleDragDrawMode();
        
        // Task 7: Clean up all custom circles on component destroy
        // Pass false to preserve geometry filter when switching views (circles will be restored when switching back)
        if (this.customCircles && this.customCircles.length > 0) {
            this.clearAllCustomCircles(false);
        }
    }

    openDetails($event: MapDetails) {
        if (this.mapElement && $event.coordinates && $event.dataset.markerVisualizationMode === MapMarkerVisualizationMode.CLUSTERS_TO_MARKER_PINS) {
            const currentZoom = this.mapElement.getZoom();
            const nextZoom = currentZoom + 1; // Increment the zoom level by 1
            this.mapElement.setCenter($event.coordinates);
            this.mapElement.setZoom(nextZoom);
        } else {
            if ($event.isPopupCall) {
                const Object = {
                    location: { x: $event.location.x, y: $event.location.y },
                    radius: $event.radius,
                };
                this.drawCircle(Object);
            } else {
                if ($event.dataset.id === OpenWeather.getId()) {
                    this.drawOpenWeatherPolygon($event);
                }
                this.DetailsOpen.emit($event);
            }
        }
    }

    drawOpenWeatherPolygon(alertEvent: any) {
        this.datapointService
            .getOpenWeatherDatapointDetails(alertEvent.datapointID)
            .subscribe((datapoint) => {
                this.resetOpenWeatherVariables();
                this.openWeatherAlertsObjects.set(
                    alertEvent.datapointId,
                    datapoint
                );
                for (let [key, value] of this.openWeatherAlertsObjects) {
                    const convertedArray = value.geometry.coordinates[0].map(
                        (coordinates) => {
                            return { lat: coordinates[1], lng: coordinates[0] };
                        }
                    );
                    const polygon = new google.maps.Polygon({
                        paths: convertedArray,
                        fillColor: OpenWeather.polygonConfiguration().fillColor, // '#00FF00',
                        fillOpacity:
                            OpenWeather.polygonConfiguration().fillOpacity,
                        strokeColor: OpenWeather.getStrokeColor(),
                        strokeOpacity:
                            OpenWeather.polygonConfiguration().strokeOpacity,
                        strokeWeight:
                            OpenWeather.polygonConfiguration().strokeWeight,
                        map: this.mapElement,
                    });
                    const params = {
                        geometryId: value.geometryID,
                        event_name: value.field_event,
                        start_date: value.field_start_date,
                        end_date: value.field_end_date,
                    };
                    this.openWeatherpolygons.push({ polygon: polygon, params });
                }
                this.openWeatherpolygons.forEach((polygonData, index) => {
                    const { polygon } = polygonData;
                    polygon.addListener("click", () =>
                        this.onPolygonClick(index, polygonData)
                    );
                });
            });
    }
    onPolygonClick(
        index: number,
        polygonData: {
            polygon: google.maps.Polygon;
            params: {
                geometryId: string;
                event_name: String;
                start_date: String;
                end_date: String;
            };
        }
    ): void {
        const {
            polygon,
            params: { geometryId, event_name, start_date, end_date },
        } = polygonData;
        const details =
            "<div> <b>Event:</b> " +
            event_name +
            "</div><div> <b>Start Date:</b> " +
            start_date +
            "</div><div> <b>End Date:</b> " +
            end_date +
            "</div>";
        this.openWeatherInfoWindow.setContent(details);
        this.openWeatherInfoWindow.setPosition(polygon.getPath().getAt(0));
        this.openWeatherInfoWindow.open(this.mapElement);
    }

    resetOpenWeatherVariables() {
        this.openWeatherInfoWindow?.close();
        this.openWeatherAlertsObjects.clear();
        this.openWeatherpolygons.forEach((polygonData, index) => {
            polygonData.params.geometryId = "";
            polygonData.polygon.setMap(null);
        });
        this.openWeatherpolygons = [];
    }
    drawCircle(crisis24: Crisis24Circle) {
        const options = {
            strokeColor: Crisis24Alert.getColor(crisis24.severity),
            strokeOpacity: 1.0,
            strokeWeight: 1,
            fillColor: Crisis24Alert.getColor(crisis24.severity),
            fillOpacity: 0.5,
            map: this.mapElement,
            center: new google.maps.LatLng(
                crisis24.location.y,
                crisis24.location.x
            ),
            clickable: true,
            radius: crisis24.radius * 1000, //Here, we convert radius in (KM) * Meter. 1 KM = 1000 Meter
        };
        const circle = new google.maps.Circle(options);
        google.maps.event.addListener(circle, "click", function (ev) {
            const contentString =
                "<div> <b>Severity:</b> " +
                crisis24.severity +
                "</div><div> <b>Radius:</b> " +
                crisis24.radius +
                '</div><div style="height: 6px; width: 100%; margin-top: 8px; border-radius: 2px; opacity: 0.8; background:' +
                Crisis24Alert.getColor(crisis24.severity) +
                '"></div>';
            const infowindow = new google.maps.InfoWindow({
                content: contentString,
            });
            const mapElement = this.mapElement;
            infowindow.setPosition(
                new google.maps.LatLng(crisis24.location.y, crisis24.location.x)
            );
            infowindow.open({
                anchor: circle,
                mapElement,
            });
        });
        this.crises24CircleObjects.push(circle);
    }

    updatePolygonPaths(
        polygon: PolygonDrawing,
        event: PolygonPathEvent<any>,
        index: number,
        type: string,
        action: string
    ) {
        polygon.isReceivingAllData = false;
        polygon.polygonData = {};
        let parsedPoints = [];
        for (let i = 0; i < event.newArr[0].length; i++) {
            parsedPoints[i] = new google.maps.LatLng(
                Number(event.newArr[0][i].lat),
                Number(event.newArr[0][i].lng)
            );
        }
        this.shapeUpdateDebouncer.next({
            event: [new google.maps.MVCArray(parsedPoints)],
            index: index,
            type: type,
            action: action,
        });
    }

    computeRectangleArea(bounds: RectangleDrawing): number {
        if (!bounds) {
            return 0;
        }
        const southWest = new google.maps.LatLng(bounds.south, bounds.west);
        const northEast = new google.maps.LatLng(bounds.north, bounds.east);
        const southEast = new google.maps.LatLng(bounds.south, bounds.east);
        const northWest = new google.maps.LatLng(bounds.north, bounds.west);
        if (google.maps.geometry) {
            return google.maps.geometry.spherical.computeArea([
                northEast,
                northWest,
                southWest,
                southEast,
            ]);
        }
    }

    computeCircleArea(radius: number): number {
        return Math.PI * Math.pow(radius, 2);
    }

    computePolygonArea(path: google.maps.MVCArray<google.maps.LatLng>) {
        if (google.maps.geometry) {
            return google.maps.geometry.spherical.computeArea(path);
        }
    }

    computePolylineDistance(path: any) {
        return google.maps.geometry.spherical.computeLength(path);
    }

    squareMToSquareMi(area: number): number {
        return area / 2589988.1103;
    }

    squareMToSquareKm(area: number): number {
        return area / 1000000;
    }

    squareMToSquareFeet(area: number) {
        return area * 10.76391041671;
    }
    mToMi(value: number): number {
        return value / 1609.34;
    }

    mToKm(value: number): number {
        return value / 1000;
    }

    mToFeet(value: number): number {
        return this.mToKm(value) * 3280.84;
    }

    mToMeter(value: number): number {
        return this.mToKm(value) * 1000;
    }

    copyAllMeasureDistance(path: any){
        const distance= this.computePolylineDistance(path);
        const distancemToKm = this.decimalPipe.transform(this.mToKm(distance), '1.0-2');
        const distancemToMi = this.decimalPipe.transform(this.mToMi(distance), '1.0-2');
        const distancemToFeet = this.decimalPipe.transform(this.mToFeet(distance), '1.0-2');
        const distancemToM = this.decimalPipe.transform(this.mToMeter(distance), '1.0-2');
        const data = `${distancemToKm} km\n${distancemToMi} mi\n${distancemToM} m\n${distancemToFeet} ft`;
        window.navigator.clipboard.writeText(data).then(
            () => this.notifService.success("Copied All data to clipboard"),
            (err) => console.error("Failed to copy measurements:", err)
        );
    }

    copyAllMeasureCircle(radius: number) {
        const area = this.computeCircleArea(radius);
        const circleAreasquareMToSquareKm = this.decimalPipe.transform(this.squareMToSquareKm(area), '1.0-2');
        const circleAreasquareMToSquareMi = this.decimalPipe.transform(this.squareMToSquareMi(area), '1.0-2');
        const circleAreasquareMToSquareM = this.decimalPipe.transform(area, '1.0-2');
        const circleAreasquareMToSquareFeet = this.decimalPipe.transform(this.squareMToSquareFeet(area), '1.0-2');
        const data = `${circleAreasquareMToSquareKm} km²\n${circleAreasquareMToSquareMi} mi²\n${circleAreasquareMToSquareM} m²\n${circleAreasquareMToSquareFeet} ft²`;
        // Copy the concatenated string to the clipboard
        window.navigator.clipboard.writeText(data).then(
            () => this.notifService.success("Copied All data to clipboard"),
            (err) => console.error("Failed to copy measurements:", err)
        );
    }

    copyAllMeasureRectangle(bounds: RectangleDrawing){
        const area = this.computeRectangleArea(bounds);
        const rectangleAreasquareMToSquareKm = this.decimalPipe.transform(this.squareMToSquareKm(area), '1.0-2');
        const rectangleAreasquareMToSquareMi = this.decimalPipe.transform(this.squareMToSquareMi(area), '1.0-2');
        const rectangleAreasquareMToSquareM = this.decimalPipe.transform(area, '1.0-2');
        const rectangleAreasquareMToSquareFeet = this.decimalPipe.transform(this.squareMToSquareFeet(area), '1.0-2');
        const data = `${rectangleAreasquareMToSquareKm} km²\n${rectangleAreasquareMToSquareMi} mi²\n${rectangleAreasquareMToSquareM} m²\n${rectangleAreasquareMToSquareFeet} ft²`;
         // Copy the concatenated string to the clipboard
         window.navigator.clipboard.writeText(data).then(
            () => this.notifService.success("Copied All data to clipboard"),
            (err) => console.error("Failed to copy measurements:", err)
        );
    }

    copyAllMeasurePolygon(path: google.maps.MVCArray<google.maps.LatLng>){
        const area = this.computePolygonArea(path);
        const rectangleAreasquareMToSquareKm = this.decimalPipe.transform(this.squareMToSquareKm(area), '1.0-2');
        const rectangleAreasquareMToSquareMi = this.decimalPipe.transform(this.squareMToSquareMi(area), '1.0-2');
        const rectangleAreasquareMToSquareM = this.decimalPipe.transform(area, '1.0-2');
        const rectangleAreasquareMToSquareFeet = this.decimalPipe.transform(this.squareMToSquareFeet(area), '1.0-2');
        const data = `${rectangleAreasquareMToSquareKm} km²\n${rectangleAreasquareMToSquareMi} mi²\n${rectangleAreasquareMToSquareM} m²\n${rectangleAreasquareMToSquareFeet} ft²`;
         // Copy the concatenated string to the clipboard
         window.navigator.clipboard.writeText(data).then(
            () => this.notifService.success("Copied All data to clipboard"),
            (err) => console.error("Failed to copy measurements:", err)
        );
    }

    onClickMeasurment(type: string, input) {
        this.notifService.success("Copied to clipboard");
        let data;
        let unit = '';
        if (type === 'squareMToSquareKm') {
            data = this.squareMToSquareKm(input);
            unit = ' km²';
        } else if (type === 'squareMToSquareMi') {
            data = this.squareMToSquareMi(input);
            unit = ' mi²';
        } else if (type === 'squareMToSquareFeet') {
            data = this.squareMToSquareFeet(input);
            unit = ' ft²';
        } else if (['computePolygonArea', 'computeCircleArea', 'computeRectangleArea'].includes(type)) {
            data = input;
            unit = ' m²';
        } else if(type === 'mToKm') {
            data = this.mToKm(input);
            unit = ' km';
        } else if(type === 'mToMi') {
            data = this.mToMi(input);
            unit = ' mi';
        } else if(type === 'mToFeet') {
            data = this.mToFeet(input);
            unit = ' ft';
        } else if(type === 'mToMeter') {
            data = this.mToMeter(input);
            unit = ' m';
        }
        window.navigator.clipboard.writeText(this.decimalPipe.transform(data, '1.0-2') + unit);
    }

    private handleImageOverlaysMapChanges(mapState: MapStateForImageOverlays) {
        switch (mapState.action) {
            case MapStateActionEnum.NONE:
                break;
            case MapStateActionEnum.UPDATE_OVERLAY:
                break;
            case MapStateActionEnum.INSERT_OVERLAY: {
                if (mapState.interactive) {
                    this.onInteractiveMapAdded(
                        mapState.overlay,
                        mapState.opacity
                    );
                    return;
                }
                let existingIndex =
                    this.datapointsPageStateService.activeImageOverlaysOnMap.findIndex(
                        (overlay) => overlay.id === mapState.overlay.id
                    );
                if (existingIndex >= 0) {
                    return;
                }
                this.mapElement.overlayMapTypes.push(mapState.map);
                this.datapointsPageStateService.activeImageOverlaysOnMap.push(
                    mapState.overlay
                );
                break;
            }
            case MapStateActionEnum.REMOVE_OVERLAY: {
                if (mapState.interactive) {
                    this.onInteractiveMapRemoved(mapState.overlay);
                    return;
                }
                let indexOfOverlay = this.mapElement.overlayMapTypes
                    .getArray()
                    .findIndex((map) => map.name === mapState.overlay.id);
                this.mapElement.overlayMapTypes.removeAt(indexOfOverlay);
                this.datapointsPageStateService.activeImageOverlaysOnMap.splice(
                    indexOfOverlay,
                    1
                );
                break;
            }
        }
    }

    onSearchAutocompleteSelected($event) {
        // geometry.location is the coordinate of the address that was picked; geometry.viewport is
        // only a suggested framing for the map. Publishing the viewport alone left the marker bound
        // to an undefined latitude and longitude, so the point behind the address profile came from
        // the map centre instead - which is wherever the map happens to be pointing, not the
        // address. That point is then reverse geocoded back into the address we send to Precisely,
        // so a drifted centre produced overlay data for a different place than the pin.
        const location = $event.geometry.location;
        this.mapStateService.activeSearchResultMarker$.next({
            latitude: this.readCoordinate(location, 'lat'),
            longitude: this.readCoordinate(location, 'lng'),
            fitBounds: $event.geometry.viewport,
        });
        // Kept so the profile can show, and query overlays with, the address that was actually
        // chosen. Reverse geocoding the pin returns the nearest feature instead, which drops the
        // house number and moves the answer to a different block.
        this.mapStateService.selectedPlaceAddress = $event.formatted_address;
        this.mapStateService.emitMarkerIsInitialized(true);
    }

    /**
     * Google hands back a LatLng whose lat/lng are methods, but a plain object with number
     * properties when the result has been serialised on the way here. Accepts both rather than
     * assuming, because the wrong one returns undefined silently and puts the marker nowhere.
     */
    private readCoordinate(location: any, key: 'lat' | 'lng'): number {
        if (!location) {
            return undefined;
        }
        return typeof location[key] === 'function' ? location[key]() : location[key];
    }

    onSearchLocationSelected(location: GMALocation) {
        this.mapStateService.activeSearchResultMarker$.next({
            longitude: location.longitude,
            latitude: location.latitude,
        });
        this.mapElement.setCenter({
            lat: location.latitude,
            lng: location.longitude,
        });
        let zoomLevel = this.mapElement.getZoom()
        if(this.datapointsPageStateService.getActiveDataset().markerVisualizationMode === MapMarkerVisualizationMode.CLUSTERS_TO_MARKER_PINS) {
            zoomLevel = zoomLevel === 4 ? 12 : zoomLevel;
        } else {
            zoomLevel = zoomLevel === 3 ? 12 : zoomLevel;
        }
        this.mapElement.setZoom(zoomLevel);
    }

    updateAddressOnDragEnd(x: any, y: any) {
        this.address = `${x},${y}`;
        // The pin is no longer where the search put it, so the chosen address no longer describes
        // it. Cleared rather than kept, so the profile falls back to reverse geocoding the new
        // position - which is the right answer once there is no chosen address to preserve.
        this.mapStateService.selectedPlaceAddress = null;
    }

    seeAddressDetails() {
        const searchBoxValue = !isUndefined(this.address)
            ? this.address.split(",")
            : this.address;
        const isFloat = function isFloat(x) {
            return !!(x % 1);
        };
        let isLatLonInput = false;
        if (!isUndefined(searchBoxValue) && searchBoxValue.length === 2) {
            const latitude = parseFloat(searchBoxValue[0].trim());
            const longitude = parseFloat(searchBoxValue[1].trim());
            if (isFloat(latitude) && isFloat(longitude)) {
                isLatLonInput = true;
                // Coordinates were typed rather than an address chosen, so there is no chosen
                // address to preserve and the profile should reverse geocode this point.
                this.mapStateService.selectedPlaceAddress = null;
                this.onSearchLocationSelected({
                    latitude: latitude,
                    longitude: longitude,
                });
            }
        }

        if (!isLatLonInput) {
            if (!this.markerIsInitialized) {
                this.initMarker();
            }
        }

        if (this.searchResultMarker$.value !== null) {
            this.dataPointsServiceState.activeSearchLocation = {
                x: this.searchResultMarker$.value.longitude,
                y: this.searchResultMarker$.value.latitude,
            };
            this.onCustomLocationDetailsSelected.emit({
                x: this.searchResultMarker$.value.longitude,
                y: this.searchResultMarker$.value.latitude,
            });
        }
    }

    getMapViewType(): { type: string; iconSource: string; displayName?: string }[] {
        return Object.values(MapViewType).map((mode) => ({
            type: mode,
            iconSource: MapIcons[mode],
            displayName: mode === MapViewType.WORLD_MAP ? 'GRAY' : mode.replace('_', ' ').toUpperCase()
        }));
    }

    onIconClick(mode: string): void {
        this.mapType = { 
            type: mode, 
            iconSource: MapIcons[mode],
            displayName: mode === MapViewType.WORLD_MAP ? 'GRAY' : mode.replace('_', ' ').toUpperCase()
        };
        this.cd.detectChanges();
    }

    public clearCrises24CircleObjectsArray() {
        if (this.crises24CircleObjects.length) {
            this.crises24CircleObjects.forEach((element) => {
                element.setMap(null);
            });
        }
    }

    // createTensorflightPolygon(params) {
    //     if (
    //         params.newSelectedValue === this.locationProfile.TENSORFLIGHT &&
    //         this.externalTensorFlightData &&
    //         this.externalTensorFlightData.status == TensorflightStatus.SUCCESS
    //     ) {
    //         this.tensorFlightPolygonData = {
    //             paths: this.externalTensorFlightData.polygonData.coordinates[0].map(
    //                 (coord) => {
    //                     return { lat: coord[1], lng: coord[0] };
    //                 }
    //             ),
    //         };

    //         if (this.isTensorflightFirstTimeFetched) {
    //             this.zoomInMapToPolygon();
    //         }

    //         this.isTensorflightFirstTimeFetched = false;
    //         this.areBoundsChanged = false;
    //     } else if (
    //         params.prevSelectedValue === this.locationProfile.TENSORFLIGHT &&
    //         params.newSelectedValue !== this.locationProfile.TENSORFLIGHT
    //     ) {
    //         this.removeTensorflightPolygon();
    //     }
    // }

    createPreciselyPolygon(params) {
        console.log("in precisely");
        if (
            params.newSelectedValue === this.locationProfile.PRECISELY_BUILDING &&
            this.externalPreciselyDataForMap
        ) {
            console.log("in precisely 2");
            this.preciselyPolygonData = {
                paths: this.externalPreciselyDataForMap.polygonData.coordinates[0].map(
                    (coord) => {
                        return { lat: coord[1], lng: coord[0] };
                    }
                ),
            };

            console.log("polygondata-",this.preciselyPolygonData);

            if (this.isPreciselyFirstTimeFetched) {
                this.zoomInMapToPolygon();
            }

            this.isPreciselyFirstTimeFetched = false;
            this.areBoundsChanged = false;
        } else if (
            params.prevSelectedValue === this.locationProfile.PRECISELY_BUILDING &&
            params.newSelectedValue !== this.locationProfile.PRECISELY_BUILDING
        ) {
            this.removePreciselyPolygon();
        }
    }

    createPreciselyWildfirePolygon(params) {
        if (
            params.newSelectedValue === this.locationProfile.PRECISELY_WILDFIRE_RISK &&
            this.externalPreciselyWildfireDataForMap
        ) {
            this.preciselyWildfirePolygonData = {
                paths: this.externalPreciselyWildfireDataForMap.polygonData.coordinates[0].map(
                    (coord) => {
                        return { lat: coord[1], lng: coord[0] };
                    }
                ),
            };

            if (this.isPreciselyWildfireFirstTimeFetched) {
                this.zoomInMapToWildfirePolygon();
            }

            this.isPreciselyWildfireFirstTimeFetched = false;
        } else if (
            params.prevSelectedValue === this.locationProfile.PRECISELY_WILDFIRE_RISK &&
            params.newSelectedValue !== this.locationProfile.PRECISELY_WILDFIRE_RISK
        ) {
            this.removePreciselyWildfirePolygon();
        }
    }

    onBoundsChange(event: any) {
        this.currentMapBounds = event;
    }

    // removeTensorflightPolygon() {
    //     this.tensorFlightPolygonData = null;
    // }

    onZoomChange(event: any) {
        this.currentZoom = event;
        this.areBoundsChanged = true;
    }

    zoomInMapToPolygon() {
        const bounds = new google.maps.LatLngBounds();
        // for (const path of this.tensorFlightPolygonData.paths) {
        //     bounds.extend(new google.maps.LatLng(path.lat, path.lng));
        // }

        for (const path of this.preciselyPolygonData.paths) {
            bounds.extend(new google.maps.LatLng(path.lat, path.lng));
        }

        const parsedBounds = JSON.parse(JSON.stringify(bounds));
        this.mapElement.fitBounds(parsedBounds);
    }

    zoomInMapToWildfirePolygon() {
        const bounds = new google.maps.LatLngBounds();

        for (const path of this.preciselyWildfirePolygonData.paths) {
            bounds.extend(new google.maps.LatLng(path.lat, path.lng));
        }

        const parsedBounds = JSON.parse(JSON.stringify(bounds));
        this.mapElement.fitBounds(parsedBounds);
    }

    getDefaultIconUrl() {
        return "../../../assets/icons/mapIcons/icon-pin.png";
    }

    // createAddressProfileTensorflightPolygon(params) {
    //     if (params) {
    //         this.tensorFlightPolygonData = {
    //             paths: params.coordinates[0].map((coord) => {
    //                 return { lat: coord[1], lng: coord[0] };
    //             }),
    //         };
    //         this.zoomInMapToPolygon();
    //     } else {
    //         this.removeTensorflightPolygon();
    //     }
    // }

    createAddressProfilePreciselyPolygon(params) {
        // The see-info payload carries the bare coordinates array, while a GeoJSON geometry object
        // arrives as { type, coordinates } - accept either rather than reading .coordinates off an
        // array and throwing.
        const ring = Array.isArray(params) ? params[0] : (params && params.coordinates ? params.coordinates[0] : null);

        if (ring && ring.length) {
            this.preciselyPolygonData = {
                paths: ring.map((coord) => {
                    return { lat: coord[1], lng: coord[0] };
                }),
            };
            this.zoomInMapToPolygon();
        } else {
            this.removePreciselyPolygon();
        }
    }

    prepareHeatMap(response: HeatmapResponse) {
        if (!google.maps.visualization?.HeatmapLayer) {
            // HeatmapLayer was decommissioned in Maps JS v3.65.1c.
            this.notifService.error(
                'Heatmap is unavailable on this version of Google Maps'
            );
            return;
        }

        let heatmapData: google.maps.visualization.WeightedLocation[] = [];
        let hasSomeValue = response.data.some((value) => value.weight > 0);

        response.data.forEach((value) => {
            let weightedLocation: google.maps.visualization.WeightedLocation = {
                location: new google.maps.LatLng(
                    value.latitude,
                    value.longitude
                ),
                weight: value.weight,
            };
            heatmapData.push(weightedLocation);
        });

        let heatMap = new google.maps.visualization.HeatmapLayer({
            data: heatmapData,
            map: this.mapElement,
        });

        var gradientForValues = [
            "rgba(0, 255, 0, 0)", // Transparent green
            'rgb(0, 255, 0)',     // Green
            'rgb(127, 255, 0)',   // Chartreuse Green
            'rgb(255, 255, 0)',   // Yellow
            'rgb(255, 165, 0)',   // Orange
            'rgb(255, 0, 0)'      // Red
        ];

        let gradientForZeros = [
            "rgba(0, 255, 0, 0)", // Transparent green
            "rgba(0, 255, 0, 1)", // Solid green
        ];

        heatMap.set("radius", heatMap.get("radius") ? null : 1);
        if (!hasSomeValue) {
            heatMap.set("gradient", gradientForZeros);
        } else {
            heatMap.set("gradient", gradientForValues);
        }

        heatMap.set("dissipating", false);
        heatMap.set("opacity", 0.6);
        this.heatMap = heatMap;
    }

    onPolygonClickInfo(
        index: number,
        data: {
            polygon: google.maps.Polygon;
            params: {
                geometryId: string;
                event_name: String;
                start_date: String;
                end_date: String;
            };
        },
        event: google.maps.PolyMouseEvent
    ): void {
        const vertexIdx = event.vertex;
        if (vertexIdx != null && vertexIdx >= 0) {
          const pivotIdx = this.pivotInfo[index]?.index;

          if (!this.polygonLocked[index] || vertexIdx === pivotIdx) {
            const point = data.polygon.getPath().getAt(vertexIdx);
            this.vertexInfoLat = point.lat();
            this.vertexInfoLng = point.lng();
            this.selectedPolygonIndex = index;
            this.selectedVertexIndex = vertexIdx;
            this.vertexInfoWindow.open();
          }
        } else {
          this.infoWindows.toArray()[index].open();
        }
    }

    onPolygonRightClick(
        index: number,
        polygon: PolygonDrawing,
        event: google.maps.PolyMouseEvent
    ): void {
        const path = polygon.polygon.getPath().getArray();
        if (path.length === 0) return;

        const clickedVertex = event?.vertex;
        const vertexIdx = (typeof clickedVertex === 'number' && clickedVertex >= 0 && clickedVertex < path.length)
            ? clickedVertex
            : 0;
        const point = path[vertexIdx];

        this.vertexInfoLat = point.lat();
        this.vertexInfoLng = point.lng();
        this.selectedPolygonIndex = index;
        this.selectedVertexIndex = vertexIdx;
        this.vertexInfoWindow.open();
    }

    onRotateToggleChange(event: MatSlideToggleChange) {
        if (this.selectedPolygonIndex >= 0) {
            if (event.checked) {
                this.lockPolygon(this.selectedPolygonIndex);
            } else {
                this.unlockPolygon(this.selectedPolygonIndex);
            }
        }
    }

    ngAfterViewInit() {
        const n = this.polygons.select.length;
        this.polygonLocked = Array(n).fill(false);
        this.polygonMoveEnabled = Array(n).fill(false);
        this.shapeCoords = Array(n).fill(null).map(() => []);
        this.sessionBaseCoords = Array(n).fill(null).map(() => []);
        this.sessionStartAngle = Array(n).fill(0);
        this.pivotInfo = Array(n).fill(null);
        this.isRotating = Array(n).fill(false);
        this.prevCount = n;
        this.polarCoords = Array(n).fill(null).map(() => []);
        this.sessionBasePolar = Array(n).fill(null).map(() => []);
        this.sessionStartHeading = Array(n).fill(0);
        this.initialiseArrays(this.polygons.select.length);
        for (let i = 0; i < n; i++) {
            const path = this.polygons.select[i].polygon.getPath().getArray();
            this.shapeCoords[i] = path.map(pt => ({ lat: this.roundCoord(pt.lat()), lng: this.roundCoord(pt.lng()) }));
            const pivot = new google.maps.LatLng(this.shapeCoords[i][0].lat, this.shapeCoords[i][0].lng);
            this.polarCoords[i] = path.map(v => this.toPolar(pivot, v));
        }
        this.attachListenersForAll();
    }

    onPolygonDragStart(event: google.maps.MouseEvent, i: number) {
        if (this.polygonLocked[i] && !this.rotating[i]) {
            this.rotating[i] = true;
            this.undoAvailable[i] = true;
            const startPt = { lat: event.latLng.lat(), lng: event.latLng.lng() };
            this.rotationSessionStartAngle[i] = this.computeAngle(startPt, this.lockedVertexCoords[i]!);
            this.rotationSessionBaseCoords[i] = this.rotationBaseCoords[i].map(c => ({ ...c }));
        }
    }

    onPolygonDragEnd(poly: any, i: number) {
        const arr = poly.getPath().getArray();
        const coords = arr.map(pt => ({
            lat: this.roundCoord(pt.lat()),
            lng: this.roundCoord(pt.lng())
        }));
        if (this.polygonLocked[i] && this.isRotating[i]) {
            // Keep polygon editable after rotation so vertices remain visible
            this.polygons.select[i].isEditable = true;
            this.shapeCoords[i] = coords;
            this.isRotating[i] = false;
            this.rotating[i] = false;
            this.updatePolygonPaths(
                { polygon: poly }, { newArr: [arr], index: i } as any,
                i, MapShape.POLYGON, MapDrawType.FILTER
            );
        } else if (!this.polygonLocked[i]) {
            this.infoWindows.toArray()[i].open();
            this.shapeCoords[i] = coords;
            this.updatePolygonPaths(
                { polygon: poly }, { newArr: [arr], index: i } as any,
                i, MapShape.POLYGON, MapDrawType.FILTER
            );
        }
    }

    ngDoCheck() {
        const n = this.polygons.select.length;
        if (n !== this.prevCount) {
            this.initialiseArrays(n);
            this.polygonLocked = this.polygonLocked.map(val => val === true);
            this.isRotating = this.isRotating.map(val => val === true);;
            this.sessionBaseCoords = Array(n).fill(null).map(() => []);
            this.sessionStartAngle = Array(n).fill(0);
            this.pivotInfo = this.pivotInfo.map((val, i) => val !== null ? val : null);
            this.shapeCoords = this.shapeCoords.map((val, i) =>
                Array.isArray(val) && val.length > 0 ? val : []
              );
            for (let i = 0; i < n; i++) {
                const path = this.polygons.select[i].polygon.getPath().getArray();
                this.shapeCoords[i] = path.map(pt => ({ lat: this.roundCoord(pt.lat()), lng: this.roundCoord(pt.lng()) }));
            }
            this.clearPathListeners();
            this.attachListenersForAll();
            this.prevCount = n;
        }
    }

    private resetLocks() {
        const n = this.polygons.select.length;
        this.polygonLocked = Array(n).fill(false);
        this.polygonMoveEnabled = Array(n).fill(false);
        this.rotationBaseCoords = Array(n).fill(null).map(() => []);
        this.rotationSessionCoords = Array(n).fill(null).map(() => []);
        this.rotationSessionStartAngle = Array(n).fill(0);
        this.lockedVertexCoords = Array(n).fill(null);
        this.rotating = Array(n).fill(false);
    }

    onPolygonDrag(event: google.maps.MouseEvent, i: number) {
        if (!this.polygonLocked[i]) return;
        const pivot = this.pivotInfo[i]!;
        const pivotLL = new google.maps.LatLng(pivot.lat, pivot.lng);
        const currHdg = google.maps.geometry.spherical.computeHeading(
            pivotLL,
            event.latLng
        );

        if (!this.isRotating[i]) {
            this.isRotating[i] = true;
            this.sessionStartHeading[i] = currHdg;
            const livePts = this.polygons.select[i].polygon.getPath().getArray();
            this.sessionBasePolar[i] = livePts.map(v => this.toPolar(pivotLL, v));
            this.polarCoords[i] = this.sessionBasePolar[i].map(p => ({ ...p }));
            return;
        }

        const delta = this.normalizeAngle(currHdg - this.sessionStartHeading[i]);
        const rotated = this.sessionBasePolar[i].map(pol =>
            this.fromPolar(pivotLL, { dist: pol.dist, hdg: pol.hdg + delta })
        );
        rotated[pivot.index] = pivotLL;

        this.zone.runOutsideAngular(() => {
            const path = this.polygons.select[i].polygon.getPath();
            this.suppressSetAt = true;
            rotated.forEach((ll, idx) => path.setAt(idx, ll));
            this.suppressSetAt = false;
        });
    }

    lockPolygon(i: number) {
        this.polygonLocked[i] = true;
        this.isRotating[i] = false;
        // Ensure polygon is editable so vertices are visible for rotation
        if (this.polygons.select[i]) {
            this.polygons.select[i].isEditable = true;
        }
        
        // Use the stored vertex index if available, otherwise find by coordinates
        let idx = this.selectedVertexIndex;
        
        if (idx < 0) {
            const base = this.shapeCoords[i];
            const lat = this.roundCoord(this.vertexInfoLat);
            const lng = this.roundCoord(this.vertexInfoLng);
            idx = base.findIndex(p => p.lat === lat && p.lng === lng);
        }
        
        const base = this.shapeCoords[i];
        const lat = base[idx]?.lat || this.roundCoord(this.vertexInfoLat);
        const lng = base[idx]?.lng || this.roundCoord(this.vertexInfoLng);
        
        this.pivotInfo[i] = { lat, lng, index: idx };
        this.lockedVertexCoords[i] = { lat, lng, index: idx };
        const pivot = new google.maps.LatLng(lat, lng);
        const path   = this.polygons.select[i].polygon.getPath().getArray();
        this.polarCoords[i] = path.map(v => this.toPolar(pivot, v));
    }

    private initialiseArrays(n: number): void {
        this.polygonLocked = this.polygonLocked.map(val => val === true);
        this.isRotating = this.isRotating.map(val => val === true);
        this.rotating = Array(n).fill(false);
        this.shapeCoords = this.shapeCoords.map((val, i) =>
            Array.isArray(val) && val.length > 0 ? val : []
          );
        this.rotationBaseCoords = Array(n).fill(null).map(() => []);
        this.sessionBaseCoords = Array(n).fill(null).map(() => []);
        this.sessionStartAngle = Array(n).fill(0);
        this.pivotInfo = this.pivotInfo.map((val, i) => val !== null ? val : null);
        this.polarCoords = this.polarCoords.map((val, i) =>
            Array.isArray(val) && val.length > 0 ? val : []
          );
        this.sessionBasePolar = Array(n).fill(null).map(() => []);
        this.sessionStartHeading = Array(n).fill(0);
        this.undoAvailable = Array(n).fill(false);
    }

    unlockPolygon(i: number) {
        this.polygonLocked[i] = false;
        this.pivotInfo[i] = null;
        this.lockedVertexCoords[i] = null;
        this.polarCoords[i] = [];
        // Re-enable vertices so polygon can be rotated again
        if (this.polygons.select[i]) {
            this.polygons.select[i].isEditable = true;
        }
    }

    onPathsChange(wrapper: any,
        event: PolygonPathEvent<any>,
        i: number,
        shape: any,
        drawType: any) {
        // Prevent infinite loop during rotation
        if (this.suppressSetAt) {
            return;
        }

        const path = wrapper.polygon.getPath();
        const pts = path.getArray();
        const coords = pts.map(p => ({
            lat: this.roundCoord(p.lat()),
            lng: this.roundCoord(p.lng())
        }));
        let pivotLL: google.maps.LatLng;
        if (this.polygonLocked[i]) {
            const pivot = this.pivotInfo[i]!;
            coords[pivot.index] = { lat: pivot.lat, lng: pivot.lng };
            this.suppressSetAt = true;
            path.setAt(pivot.index, new google.maps.LatLng(pivot.lat, pivot.lng));
            this.suppressSetAt = false;
            pivotLL = new google.maps.LatLng(pivot.lat, pivot.lng);
        } else {
            pivotLL = pts[0];
        }
        this.rotationBaseCoords[i] = coords.map(c => ({ ...c }));
        this.refreshPolarCaches(i, pts, pivotLL);
        this.isRotating[i] = false;
        if(!this.polygonLocked[i]) {
            this.updatePolygonPaths(wrapper, event, i, shape, drawType);
        }

    }


    private getCentroid(points: {lat:number,lng:number}[]) {
        const sum = points.reduce((a,p) => ({ lat: a.lat+p.lat, lng: a.lng+p.lng }), {lat:0, lng:0});
        return { lat: sum.lat/points.length, lng: sum.lng/points.length };
    }

    private computeAngle(
        pt: {lat:number,lng:number},
        center: {lat:number,lng:number}
      ) {
        return Math.atan2(pt.lat - center.lat, pt.lng - center.lng);
    }

    private rotatePoint(
        pt: {lat:number,lng:number},
        center: {lat:number,lng:number},
        angle: number
      ) {
        const dx = pt.lat - center.lat;
        const dy = pt.lng - center.lng;
        return {
            lat: center.lat + dx * Math.cos(angle) - dy * Math.sin(angle),
            lng: center.lng + dx * Math.sin(angle) + dy * Math.cos(angle)
        };
    }

    private onVertexMoved(polyIdx: number, movedIdx: number) {
        if (this.polygonLocked[polyIdx] || this.rotating[polyIdx]) {
            return;
        }
        this.updatePolygonPaths(
            this.polygons.select[polyIdx],
            { newArr: [this.originalCoords[polyIdx]], index: polyIdx } as any,
            polyIdx,
            MapShape.POLYGON,
            MapDrawType.FILTER
        );
    }

    private rotatePolygonAroundLockedVertex(i: number, moveEvent: any) {
        const pivot = this.pivotInfo[i]!;
        const pivotLL = new google.maps.LatLng(pivot.lat, pivot.lng);
        const movedLL = new google.maps.LatLng(moveEvent.coords.lat, moveEvent.coords.lng);
        const currHdg = google.maps.geometry.spherical.computeHeading(pivotLL, movedLL);

        if (!this.isRotating[i]) {
            this.isRotating[i] = true;
            this.sessionStartHeading[i] = currHdg;
            const livePts = this.polygons.select[i].polygon.getPath().getArray();
            this.sessionBasePolar[i] = livePts.map(v => this.toPolar(pivotLL, v));
            this.polarCoords[i] = this.sessionBasePolar[i].map(p => ({ ...p }));
            this.lastDragPoint[i] = { lat: moveEvent.coords.lat, lng: moveEvent.coords.lng };
            return;
        }

        const delta = this.normalizeAngle(currHdg - this.sessionStartHeading[i]);
        const rotated = this.sessionBasePolar[i].map(pol =>
            this.fromPolar(pivotLL, { dist: pol.dist, hdg: pol.hdg + delta })
        );
        rotated[pivot.index] = pivotLL;

        this.zone.runOutsideAngular(() => {
            const path = this.polygons.select[i].polygon.getPath();
            this.suppressSetAt = true;
            rotated.forEach((ll, idx) => path.setAt(idx, ll));
            this.suppressSetAt = false;
        });

        // Clear cache so icon position updates with the rotated polygon
        this.polygonIconPositionCache.clear();

        this.lastDragPoint[i] = { lat: moveEvent.coords.lat, lng: moveEvent.coords.lng };
    }

    private roundCoord(val: number): number {
        return Math.round(val * this.ROUND_COORD_VALUE) / this.ROUND_COORD_VALUE;
    }

    private toPolar(pivot: google.maps.LatLng, p: google.maps.LatLng): PolarVertex {
        return {
            dist: google.maps.geometry.spherical.computeDistanceBetween(pivot, p),
            hdg: google.maps.geometry.spherical.computeHeading(pivot, p)
        };
    }

    private fromPolar(pivot: google.maps.LatLng, polar: PolarVertex): google.maps.LatLng {
        return google.maps.geometry.spherical.computeOffset(pivot, polar.dist, polar.hdg);
    }

    private normalizeAngle(deg: number): number {
        return ((deg + this.DEGREE_540) % this.DEGREE_360) - this.DEGREE_180;
    }

    private refreshPolarCaches(
        i: number,
        pts: google.maps.LatLng[],
        pivotLL: google.maps.LatLng
    ): void {
        this.polarCoords[i] = pts.map(v => this.toPolar(pivotLL, v));
        this.sessionBasePolar[i] = this.polarCoords[i].map(p => ({ ...p }));
    }

    private isSelfIntersecting(coords: { lat: number; lng: number }[]): boolean {
        const n = coords.length;
        const next = (idx: number) => (idx + 1) % n;

        const segmentsIntersect = (p1: any, p2: any, p3: any, p4: any): boolean => {
            const ccw = (a: any, b: any, c: any) =>
                (c.lng - a.lng) * (b.lat - a.lat) - (c.lat - a.lat) * (b.lng - a.lng);

            const d1 = ccw(p1, p2, p3);
            const d2 = ccw(p1, p2, p4);
            const d3 = ccw(p3, p4, p1);
            const d4 = ccw(p3, p4, p2);

            if (((d1 > 0 && d2 < 0) || (d1 < 0 && d2 > 0)) &&
                ((d3 > 0 && d4 < 0) || (d3 < 0 && d4 > 0))) { return true; }

            const onSeg = (a: any, b: any, c: any) =>
                Math.min(a.lat, b.lat) <= c.lat && c.lat <= Math.max(a.lat, b.lat) &&
                Math.min(a.lng, b.lng) <= c.lng && c.lng <= Math.max(a.lng, b.lng);

            if (d1 === 0 && onSeg(p1, p2, p3)) return true;
            if (d2 === 0 && onSeg(p1, p2, p4)) return true;
            if (d3 === 0 && onSeg(p3, p4, p1)) return true;
            if (d4 === 0 && onSeg(p3, p4, p2)) return true;

            return false;
        };

        for (let i = 0; i < n; i++) {
            const a1 = coords[i];
            const a2 = coords[next(i)];
            for (let j = i + 1; j < n; j++) {
                if (j === i || next(i) === j || i === next(j)) continue;
                const b1 = coords[j];
                const b2 = coords[next(j)];
                if (segmentsIntersect(a1, a2, b1, b2)) return true;
            }
        }
        return false;
    }

    private revertPolygon(i: number): void {
        const poly = this.polygons.select[i].polygon as google.maps.Polygon;
        const wasEditable = poly.getEditable?.();
        if (wasEditable) poly.setEditable(false);
        const path = poly.getPath();
        this.suppressSetAt = true;
        path.clear();
        this.shapeCoords[i].forEach(c =>
            path.push(new google.maps.LatLng(c.lat, c.lng)));
        this.suppressSetAt = false;
        if (wasEditable) poly.setEditable(false);
        this.isRotating[i] = false;
        this.rotating[i] = false;
        setTimeout(() => this.hideUndoButton(), 100);
    }

    private attachListenersForAll(): void {
        this.polygons.select.forEach((polyWrapper, i) => {
            const path = polyWrapper.polygon.getPath();
            this.shapeCoords[i] = path.getArray().map(p => ({
                lat: this.roundCoord(p.lat()),
                lng: this.roundCoord(p.lng())
            }));
            this.zone.runOutsideAngular(() => {
                this.pathListeners.push(
                    path.addListener('set_at', () => this.validatePath(i)),
                    path.addListener('insert_at', () => this.validatePath(i))
                );
            });
        });
    }

    private clearPathListeners(): void {
        this.pathListeners.forEach(l => l.remove());
        this.pathListeners = [];
    }

    private validatePath(i: number): void {
        if (this.suppressSetAt) return;
        if (this.polygonLocked[i] && this.isRotating[i]) return;
        const path = this.polygons.select[i].polygon.getPath();
        const coords = path.getArray().map(p => ({
            lat: this.roundCoord(p.lat()),
            lng: this.roundCoord(p.lng())
        }));
        if (!this.isSelfIntersecting(coords)) {
            this.shapeCoords[i] = coords;
            return;
        }
        this.revertPolygon(i);
        this.snackBar.open(
            'Polygon cannot intersect itself - reverted to previous shape',
            'X',
            { duration: 3000, panelClass: 'error-snackbar' }
        );
    }

    private hideUndoButton(): void {
        const undoBtn = document.querySelector('[aria-label="Undo last edit"]');
        if (undoBtn) {
          (undoBtn as HTMLElement).style.display = 'none';
        }
    }

    removePreciselyPolygon() {
        this.preciselyPolygonData = null;
    }

    removePreciselyWildfirePolygon() {
        this.preciselyWildfirePolygonData = null;
    }
}

interface GeojsonMapItem {
    geojson: any; // geojson
    showInfo: boolean;
    clickedLocation?: LatLngLiteral;
    style: MapTypeStyle;
    regionId?: number;
}

interface PolarVertex {
    dist: number;
    hdg: number;
}
